export default {
    address: {
        city: "Kaupunki",
        city_locality: "Kaupunki \/ Paikkakunta",
        country: "Maa",
        line1: "Osoiterivi 1",
        line2: "Osoiterivi 2",
        postal_code: "Postinumero",
        state: "Osavaltio",
        state_region: "Osavaltio\/alue"
    },
    alerts: {
        account_2fa: "Suojaa tilisi kaksivaiheisella todennuksella.",
        account_2fa_success: "Kaksivaiheinen todennus on käytössä.",
        activate_instruction: "Automaattisen arvostelujen keräämisen käyttöönotto yrittää pyytää arvostelua kohteelta {count}. Tarkista mallipohjasi ennen käyttöönottoa.",
        activate_intro: "Pyydä jatkuvasti arvosteluja strategiasi perusteella.",
        agency_mcp_server: "Yhdistä Claude tai mikä tahansa MCP asiakasohjelma toimistosi MCP palvelin. Valtuutetut avustajat voivat hallita toimistosi projekteja, asiakkaita ja tiimiä puolestasi.",
        agency_sso: "Yhdistä OpenID Connect -identiteetintarjoaja asiakkaan kirjautumista varten.",
        ai_assistant: "Yrityksesi nimi ja kuvaus vaaditaan tekoälyn käyttämiseksi arvosteluehdotuksissa ja vastauksissa.",
        ai_description_required: "Lisää yrityskuvaus kohtaan Asetukset → Projekti, jotta voit käyttää tekoälytyökaluja.",
        ai_review_pages: "Salli tekoälyn arvosteluehdotukset valitsemillasi sivuilla.",
        api_key_roll: "Haluatko varmasti vaihtaa API-avaimesi? Tämä vaikuttaa kaikkiin sitä käyttäviin sovelluksiin.",
        ask_confirm: "Haluatko varmasti pyytää arvosteluja kohteelta {count}? Tämä ajoittaa pyynnöt kaikille asiakkaille, joilta ei ole vielä kysytty.",
        automate_highlights: "Korosta automaattisesti lauseita uusissa myönteisissä arvosteluissa.",
        automate_replies: "Julkaise tekoälyvastaukset automaattisesti uusiin Google- ja Facebook-arvosteluihin. Vaatii [Google- tai Facebook-integraation](/settings/integrations?tab=review).",
        cname_delete: "Haluatko varmasti poistaa CNAME-tietueen: {cname_name}?",
        cname_not_configured: "Tätä tietuetta ei ole vielä määritetty. Odota hetki...",
        cname_warning: "Asiakkaillesi jo lähetetyissä viesteissä on rikkinäisiä linkkejä.",
        connection_disabled: "Yhteys on poistettu käytöstä. Yhdistä uudelleen.",
        customer_archive: "Haluatko varmasti arkistoida asiakkaan: {customer_name}? Lähettämättömät viestit peruutetaan.",
        customer_cancel: "Haluatko varmasti peruuttaa kaikki lähettämättömät viestit asiakkaalle: {customer_name}?",
        customer_ingest: "Sisällytä tämä sähköpostiosoite Piilokopio-kenttään, kun lähetät asiakkaillesi sähköposteja, jotta heidän nimensä ja sähköpostiosoitteensa tuodaan automaattisesti.",
        customer_resubscribe: "Haluatko varmasti tilata asiakkaan uudelleen: {customer_name}?",
        customer_unarchive: "Haluatko varmasti poistaa asiakkaan arkiston: {customer_name}?",
        customer_unsubscribe: "Haluatko varmasti peruuttaa asiakkaan {customer_name} tilauksen?",
        customer_unsubscribe_all: "Haluatko varmasti peruuttaa {count} vastaanottajan tilauksen tämän projektin viesteistä?",
        delete: "Oletko varma, että haluat poistaa tiedostot {model}: {name}?",
        delete_count: "Oletko varma, että haluat poistaa {count}?",
        domain_agency: "Lisää oma lähettävä verkkotunnus, jotta toimistosi voi olla täysin white label -periaatteella.",
        domain_delete: "Haluatko varmasti poistaa verkkotunnuksen: {name}? Lähetämme edelleen sähköposteja omasta verkkotunnuksestamme.",
        domain_dmarc: "Lisää DMARC-tietue verkkotunnukseesi vähentääksesi sähköpostien joutumista roskapostiksi.",
        domain_project: "Lisää lähettävä verkkotunnus, jotta voimme lähettää sähköposteja asiakkaillesi omasta verkkotunnuksestasi.",
        export_confirm: "Oletko varma, että haluat viedä kaikki {model} -tiedostosi?",
        export_count: "Oletko varma, että haluat viedä tiedoston {count}?",
        export_link: "Latauslinkki lähetetään osoitteeseen {email} pian pyynnön tekemisen jälkeen.",
        highlights_save_disabled: "Voit halutessasi poistaa kohokohtia kaikista arvosteluista, joissa niitä on tällä hetkellä.",
        highlights_save_enabled: "Jos haluat luoda korostukset kaikille positiivisille arvostelut, valitse alla oleva ruutu. Jos muutat vain korostusväriä, jätä ruutu valitsematta.",
        integration_disconnect: "Haluatko varmasti katkaista yhteyden palveluun {integration_name}?",
        integration_sync: "Oletko varma, että haluat synkronoida {integration_name}-tilisi? Tuomme tietojasi jatkuvasti puolestasi.",
        intro: "Oletko valmis saamaan lisää hyviä arvosteluja asiakkailtasi? Tuo asiakkaasi aloittaaksesi. Pyydä sitten arvosteluja manuaalisesti tai paina Automatisoi-painiketta ja anna arvostelujen virrata sisään.",
        logout: "Haluatko varmasti kirjautua ulos?",
        mcp_server: "Yhdistä Claude tai mikä tahansa MCP asiakas tähän projektiin. MCP palvelin avulla tekoälyavustajat voivat lukea ja hallita arvosteluja, asiakkaita ja viestejä puolestasi.",
        member_confirm: "Haluatko varmasti poistaa itsesi? Menetät pääsyn tähän projektiin.",
        member_confirm_all: "Haluatko varmasti poistaa itsesi? Menetät pääsyn kaikkiin projekteihisi.",
        member_other_confirm: "Haluatko varmasti poistaa kohteen {noun}: {name}? Hän menettää pääsyn tähän projektiin.",
        member_other_confirm_all: "Oletko varma, että haluat poistaa {noun} {name}? He menettävät pääsyn kaikkiin projekteihinsa.",
        message_cancel: "Haluatko varmasti peruuttaa tämän viestin?",
        message_cancel_all: "Haluatko varmasti peruuttaa {count}? Tämän toiminnon voi suorittaa vain lähettämättömille viesteille.",
        message_delete: "Haluatko varmasti poistaa tämän viestin?",
        oauth_client_revoke: "Haluatko varmasti peruuttaa käyttöoikeudet käyttäjälle {client}? Kaikki aktiiviset istunnot katkaistaan välittömästi.",
        project_summary: "Yhteenvetoa ei voida luoda tällä hetkellä.",
        project_suspend: "Haluatko varmasti keskeyttää projektin: {project_name}?",
        project_unsuspend: "Haluatko varmasti poistaa projektin keskeytyksen: {project_name}?",
        review_delete: "Haluatko varmasti poistaa tämän arvostelun? Tätä toimintoa ei voi perua.",
        review_page_confirm: "Haluatko varmasti tallentaa muutoksesi?",
        review_page_confirmation: "Näytä vahvistusviesti onnistumissivulla valitun arvion perusteella.",
        review_page_default: "Oletko varma, että haluat tehdä arviointisivusta {name} oletussivusi? Tätä sivua käytetään, jos arviointipyynnölle ei ole määritetty toista sivua.",
        review_page_delete: "Haluatko varmasti poistaa arvostelusivun: {name}? Kaikki asiakkaat, jotka tällä hetkellä ohjataan tälle sivulle, ohjataan oletussivullesi.",
        review_page_delete_all: "Oletko varma, että haluat poistaa {count}? Oletusarvostelusivuasi ei poisteta.",
        review_page_fields: "Käytä kenttiä asiakastietojen tallentamiseen arvostelua jättäessään. Lisää lomakkeeseen kenttiä ja näytä ne ehdollisesti, kun asiakkaat valitsevat arvosanan.",
        review_page_instructions: "Näytä ohjeet suoraan lomakkeen yläpuolella luokituksen valinnan jälkeen.",
        review_page_location_picker: "Anna asiakkaiden valita mikä tahansa sijainti projektissasi arviointia varten. Tämä valitaan etukäteen, jos arviointisivu on tarkoitettu näytettäväksi tietylle sijainnille.",
        review_page_locations: "Valitse sijainnit, joiden tulisi käyttää tätä arviointisivua. Sijainti voidaan liittää vain yhdelle arviointisivulle. Jos sijainnille ei ole liitetty sivua, se käyttää oletusarvoista arviointisivua.",
        review_page_redirects: "Ohita lomake luokituksen valinnan jälkeen ja ohjaa muualle. Voit myös jakaa liikenteen useille verkkosivustoille lisäämällä useamman kuin yhden uudelleenohjauksen kutakin arviota kohden.",
        share_template_delete: "Haluatko varmasti poistaa jakomallin \"{name}\"? Tätä ei voi perua.",
        smtp_remove: "Haluatko varmasti poistaa SMTP-määritykset projektistasi? Lähettävä verkkotunnus palaa vakiomäärityksiin.",
        smtp_setup: "Lähetä sähköposteja omalta sähköpostipalvelimeltasi. Anna SMTP-tunnistetietosi. Jos palvelimesi käyttää IP-rajoituksia, lisää seuraavat järjestelmämme käyttämät IP-osoitteet sallittujen listalle: {ips}.",
        space_delete: "Haluatko varmasti poistaa työtilan: {name}? Kaikki sen sisältämät projektit poistetaan.",
        tag_rule: "Lisää positiivinen termi ja sen negatiivinen vastine. Jos se sopii, käytämme tekoälyä merkitsemään arvostelun automaattisesti jommallakummalla tagilla.",
        user_delete: "Haluatko varmasti poistaa käyttäjätilin käyttäjälle: {email}?",
        user_verify: "Vahvista sähköpostiosoitteesi ja aktivoi tilisi napsauttamalla osoitteeseen {email} lähetetyssä sähköpostiviestissä olevaa linkkiä.",
        widget_delete: "Haluatko varmasti poistaa widgetin: {name}? Widgetiä ei enää näytetä millään verkkosivustolla.",
        widget_restore: "Haluatko varmasti palauttaa widgetin {name} asetukset? Vain ulkoasu palautuu oletusarvoihin.",
        widgets_1: "Lisää tämä skripti verkkosivustosi body-osioon.",
        widgets_2: "Arvosteluseinä näyttää kaikki arvostelusi ruudukkona. Lisää tämä skripti sinne, missä haluat widgetin näkyvän.",
        widgets_3: "Arvostelunosto näyttää yhden suuren arvostelun. Lisää tämä skripti sinne, missä haluat widgetin näkyvän."
    },
    billing_statuses: {
        active: "Tilauksesi on aktiivinen.",
        canceled: "Tilauksesi on peruutettu. Päivitä jatkaaksesi.",
        ending: "Tilauksesi päättyy {date}.",
        trial: "Ilmainen kokeilujaksosi päättyy {date}.",
        trial_expired: "Ilmainen kokeilusi on päättynyt. Päivitä jatkaaksesi.",
        trial_expiring: "Ilmainen kokeilusi päättyy pian. Päivitä jatkaaksesi."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "Sähköposti",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messenger",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Lisää lähettävä verkkotunnus muokataksesi sähköpostiosoitettasi:",
        agency_robots: "Salli hakukoneiden indeksoida asiakasportaalisi.",
        ai_business_description: "Yksityiskohtainen kuvaus yrityksestäsi, joka auttaa arvosteluehdotusten ja vastausten luomisessa.",
        ai_business_name: "Yrityksesi nimi.",
        ai_highlights: "Korosta parhaat lauseet myönteisistä arvosteluistasi.",
        ai_highlights_instructions: "Kerro tekoälylle, mitä lauseita korostuksissa suositaan.",
        ai_replies: "Laadi vastauksia arvosteluihin ja automatisoi ne halutessasi.",
        ai_reply_contact: "Sisällytetään vastauksiin kielteisiin arvosteluihin.",
        ai_reply_instructions: "Kerro tekoälylle, miltä vastausten tulee kuulostaa ja mitä niihin sisällytetään.",
        ai_review_instructions: "Kerro tekoälylle, mitä arvosteluehdotuksissa mainitaan tai vältetään.",
        ai_review_suggestions: "Auta asiakkaita kirjoittamaan arvosteluja valmiilla ehdotuksilla.",
        ai_tags: "Merkitse automaattisesti arvostelut, jotka vastaavat ohjeitasi.",
        ask_location: "Arvostelulle määritettävä sijainti.",
        ask_review_page: "Sivu, jolle arvostelu tallennetaan.",
        assign_tags: "Lisää arvosteluun tagit.",
        csv_max_rows: "Jopa {count} riviä",
        dashboard_configure_settings: "Määritä projektisi asetukset.",
        dashboard_import_customers: "Tuo asiakkaasi.",
        dashboard_preview_email_templates: "Esikatsele sähköpostipohjiasi.",
        dashboard_preview_kiosk_page: "Esikatsele kioskisivuasi.",
        dashboard_preview_review_page: "Esikatsele arvostelusivuasi.",
        dashboard_preview_showcase_page: "Esikatsele esittelysivuasi.",
        logo_height: "Logon korkeus sähköposteissa ja sivuilla.",
        meta_description: "Korvaa sivun kuvaus.",
        meta_title: "Korvaa sivun otsikko.",
        mfa_password: "Anna tilisi salasana.",
        mfa_qr_code: "Skannaa QR-koodi todennussovelluksellasi.",
        mfa_security_code: "Syötä koodi todennussovelluksestasi.",
        override_ambassador: "Näytä merkki asiakkaidesi sähköposteissa, sivuilla ja widgeteissä.",
        project_name: "Yrityksesi, brändisi tai verkkosivustosi nimi.",
        project_robots: "Salli hakukoneiden indeksoida arvostelusivusi ja esitellä ne.",
        project_slug: "Käytetään asiakkaille suunnatuissa sähköposteissa ja linkeissä, jos CNAME-tietuetta ei ole määritetty.",
        review_page_copied_message: "Näytetään positiivisen arvostelun lähettämisen jälkeen.",
        review_page_email_address: "Vastaanota arvostelut tähän sähköpostiin.",
        review_page_link_reveal_position: "Missä linkit paljastetaan.",
        review_page_link_revealer_label: "Linkkien paljastava etiketti.",
        review_page_link_revealer_rating: "Näytä linkit, jos asiakas valitsee tämän tai korkeamman luokituksen. Muussa tapauksessa näytä painike niiden näyttämiseksi.",
        review_page_native_reviews: "Salli arvostelut tällä alustalla.",
        review_page_rating_selection: "Tallenna arvio ennen arvostelun lähettämistä.",
        review_page_success_button_link: "Jos tämä on tyhjä, linkki ohjaa oletusarvoisesti projektisi verkkosivustolle, muuten sivun verkkotunnukseen.",
        review_page_warning: "Asiakkaiden estäminen jättämästä julkisia arvostelut voi johtaa yrityksesi poistamiseen listauksesta.",
        review_reply_status: "Emme voi vastata tähän arvosteluun julkisesti. Voit ottaa sen sijaan yhteyttä suoraan arvostelijaan.",
        review_suggestions: "Auta asiakkaita kirjoittamaan arvostelut.",
        separate_with_commas: "Erota useita pilkuilla.",
        setup_basics: "Määritä, milloin ja miten pyydät asiakkailta arvosteluja.",
        setup_business: "Kerro meille nimi, jolla asiakkaat tuntevat sinut.",
        setup_google: "Lähetä asiakkaita Google -profiiliisi, vastaa arvostelut ja tuo olemassa olevia. Voit ohittaa tämän ja tehdä sen myöhemmin.",
        setup_location_limit: "Kokeilujaksosi sisältää yhden sijainnin. Päivitä milloin tahansa synkronoidaksesi lisää.",
        showcase_locations: "Rajoita esittely tiettyihin paikkoihin.",
        showcase_review_length: "Arvostelut on oltava vähintään näin monta merkkiä.",
        showcase_since: "Näytä tänä päivänä tai sitä ennen luodut arvostelut.",
        showcase_sources: "Rajoita esittely tiettyihin lähteisiin.",
        showcase_tags: "Rajoita esittely arvosteluihin, joissa on tietyt tagit.",
        signature_html: "Kopioi ja liitä allekirjoitus sähköpostisovellukseesi.",
        signed_up: "Asiakkaan aloituspäivämäärä.",
        twilio_webhook: "Aseta viestipalvelusi takaisinsoitto-URL-osoitteeksi.",
        widget_embed: "Sen div-säilön ID-attribuutti, jossa widget näytetään."
    },
    labels: {
        accept_all: "Hyväksy kaikki",
        access_code: "Pääsykoodi",
        access_codes: "Pääsykoodit",
        account: "Tili",
        account_sid: "Tilin SID",
        action: "Toiminta",
        actions: "Toiminnot",
        activate: "Aktivoi",
        active: "Aktiivinen",
        add: "Lisätä",
        add_agency_project: "Lisää toimistoprojekti",
        add_confirmation_message: "Lisää vahvistusviesti.",
        add_css_rules: "Lisää omat css-sääntösi.",
        add_custom_field: "Lisää mukautettu kenttä",
        add_customer: "Lisää asiakas",
        add_customers_with: "Lisää asiakkaita {model}:lla",
        add_external_link: "Lisää ulkoinen Linkki",
        add_external_links: "Lisää ulkoisia Linkit",
        add_introduction: "Lisää johdanto.",
        add_js_tags: "Lisää omat JavaScript- tagit.",
        add_legal_information: "Lisää oikeudelliset tiedot.",
        add_location: "Lisää sijainti",
        add_project: "Lisää projekti",
        add_review: "Lisää Arvostelu",
        add_source: "Lisää lähde",
        add_tag: "Lisää Tag",
        added: "Lisätty",
        address: "Osoite",
        advanced_review_pages: "Edistyneet Arvostelusivut",
        affiliates: "Tytäryhtiöt",
        age_of_reviews: "Arvostelujen ikä",
        agencies: "Toimistot",
        agency: "Toimisto",
        agency_name: "Toimiston nimi",
        agency_project: "Toimistoprojekti",
        agency_projects: "Toimistoprojektit",
        ai: "Tekoäly",
        ai_answers: "AI-vastaukset",
        ai_assistant: "Tekoälyavustaja",
        ai_auto_tagging: "Tekoälytaggaus",
        ai_highlights_instructions: "Esimerkki: Suosi lauseita palvelusta tai brändistämme.",
        ai_reply_instructions: "Esimerkki: Pidä vastaukset lyhyinä. Pyydä kielteisissä arvosteluissa ottamaan yhteyttä.",
        ai_review_instructions: "Esimerkki: Mainitse henkilökunta ja käynti. Älä mainitse hintoja.",
        ai_review_suggestions: "Tekoälyn arvosteluehdotukset",
        ai_reviews_and_replies: "Tekoälyn arvosteluehdotukset ja vastaukset",
        ai_tagging_instructions: "Esimerkki: Käytä arvosteluihin, joissa mainitaan odotusajat, hidas palvelu tai viivästykset.",
        ai_tags: "Tekoälytagit",
        ai_tools: "Tekoälytyökalut",
        all: "Kaikki",
        allowed_domains: "Sallitut verkkotunnukset",
        amount: "Määrä",
        analytics: "Analytiikka",
        and: "ja",
        anonymous_reviews: "Anonyymit Arvostelut",
        answer: "Vastaus",
        any: "Mikä tahansa",
        api: "API",
        api_key: "API-avain",
        appearance: "Ulkonäkö",
        apply: "Käytä",
        approved: "Hyväksytty",
        archive: "Arkisto",
        archive_customer: "Arkistoasiakas",
        archived: "Arkistoitu",
        at_least: "vähintään",
        at_least_days: "Vähintään {num} päivää",
        at_least_hours: "Vähintään {num} tuntia",
        at_least_months: "Vähintään {num} kuukautta",
        at_most: "enintään",
        at_most_days: "Enintään {num} päivää",
        at_most_hours: "Enintään {num} tuntia",
        at_most_months: "Enintään {num} kuukautta",
        auth_token: "Valtuutustunnus",
        authorize: "Valtuuta",
        auto_detect: "Auto",
        auto_tags: "Tekoälytagit",
        automate: "Automatisoida",
        automate_highlights: "Automatisoi korostukset",
        automate_replies: "Automatisoi vastaukset",
        automatic_review_collection: "Automaattinen arvostelujen kerääminen",
        automatically_apply_tags: "Lisää tag automaattisesti olemassa oleviin arvosteluihin",
        automating: "Automatisointi",
        avatar: "Avatar",
        avatars: "Avatarit",
        average_charge: "Keskimääräinen veloitus",
        average_review: "Keskimääräinen Arvostelu",
        background_color: "Taustaväri",
        background_image: "Taustakuva",
        back: "Takaisin",
        bcc: "BCC",
        bcc_email_address: "Piilokopio-sähköpostiosoite",
        best_to_worst: "Parhaasta huonoimpaan",
        billing: "Laskutus",
        blog: "Blogi",
        body: "Teksti",
        body_font_size: "Tekstin fonttikoko",
        bold: "Lihavoitu",
        book_a_demo: "Varaa demo",
        bottom: "Pohja",
        bottom_left: "Vasen alakulma",
        bottom_right: "Oikea alhaalla",
        build_on: "Rakenna {model}:n päälle",
        business: "Business",
        business_description: "Yrityksen kuvaus",
        business_email: "Tukisähköpostiosoite",
        business_name: "Yrityksen nimi",
        business_phone: "Tukipuhelinnumero",
        business_website: "Yrityksen verkkosivusto",
        button: "Painike",
        button_label: "Painike nimi",
        button_link: "Linkki Painike",
        button_position: "Painike sijainti",
        button_size: "Painike koko",
        buy_me_a_coffee: "Osta minulle kahvi",
        by: "kirjoittanut",
        by_signing_up: "Luomalla tilin hyväksyt meidän",
        call_to_action: "Toimintakehotus",
        cancel: "Peruuta",
        cancel_1_message: "Peruuta 1 viesti",
        cancel_message: "Peruuta viesti",
        cancel_messages: "Peruuta {count} Viestit",
        cancel_subscription: "Peruuta tilaus",
        cancel_unsent_messages: "Peruuta lähettämättömät viestit",
        canceled: "Peruutettu",
        center: "Keskusta",
        change: "Muuttaa",
        change_key: "Vaihda API-avaintasi",
        change_plan: "Muuta suunnitelmaa",
        changelog: "Muutosloki",
        channel: "Kanava",
        channels: "Kanavat",
        characters: "Merkkiä",
        charges_avg: "Keskimääräisen maksun on oltava vähintään",
        charges_count: "Veloitusten määrän on oltava vähintään",
        charges_sum: "Kokonaisveloitusten on oltava vähintään",
        chat_with_us: "Keskustele kanssamme",
        checkbox: "Valintaruutu",
        claude: "Claude",
        clear: "Tyhjennä",
        clear_highlights_from_reviews: "Poista kohokohdat kaikista arvosteluista",
        clicked: "Klikattu",
        client: "Client",
        client_id: "Client ID",
        clients: "Asiakkaat",
        close: "Lähellä",
        cloudflare_warning: "Jos käytät Cloudflarea, välityspalvelimesi on oltava pois päältä.",
        cname: "CNAME",
        cname_setup_incomplete: "Asennus keskeneräinen - poistetaan {date}",
        cname_ssl_pending: "Odotetaan SSL-varmennetta",
        cname_status_for: "CNAME-tila kohteelle",
        code_editor: "Koodieditori",
        collapse: "Kutista",
        collect_reviews_anywhere: "Kerää arvostelut mistä tahansa",
        color: "Väri",
        colors: "Värit",
        commission_rate: "Palkkioprosentti",
        commission_status_approved: "Hyväksytty",
        commission_status_paid: "Maksettu",
        commission_status_pending: "Odottaa",
        commission_status_reversed: "Käänteinen",
        community: "Yhteisö",
        company: "Yritys",
        complained: "Valitus tehty",
        confirm_new_password: "Vahvista uusi salasana",
        confirmation_message: "Vahvistusviesti",
        configure: "Määritä",
        connect: "Yhdistä",
        connect_bank: "Yhdistä pankkitili",
        connect_google: "Yhdistä Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Yhdistetty",
        consent_preferences: "Suostumusasetukset",
        contact_customer: "Ota yhteyttä asiakkaaseen",
        contact_form: "Yhteydenottolomake",
        contact_support: "Ota yhteyttä tukeen.",
        contact_us: "Ota yhteyttä",
        container_element: "Säiliöelementti",
        context: "Konteksti",
        continue: "Jatkaa",
        continue_with_google: "Jatka Googlen kanssa",
        cookie_category_analytics: "Analytiikka",
        cookie_category_essential: "Olennainen",
        cookie_category_functional: "Toiminnallinen",
        cookie_category_marketing: "Markkinointi",
        cookie_consent_banner: "Evästeiden suostumusbanneri",
        cookie_consent_scope_all: "Näytä kaikille",
        cookie_consent_scope_eea: "Näytä vain ETA-alueen ja Yhdistyneen kuningaskunnan vierailijoille",
        cookie_consent_scope_none: "Älä näytä",
        cookie_policy: "Evästekäytäntö",
        cookie_preference: "Evästeasetukset",
        copied: "Kopioitu",
        copied_message: "Kopioitu viesti",
        copy: "Kopioi",
        copy_embed_code: "Kopioi upotuskoodi",
        copy_signature: "Kopioi Allekirjoitus",
        copy_source_code: "Kopioi lähdekoodi",
        copy_to_all_ratings: "Kopioi kaikkiin arvioihin",
        copy_uuid: "Kopioi UUID",
        create: "Luoda",
        create_account: "Luo tili",
        create_agency: "Luo toimisto",
        create_cname: "Luo CNAME-tietue ja osoita se kohteeseen",
        create_external_link: "Luo ulkoinen Linkki",
        create_field: "Luo kenttä",
        create_link: "Luo Linkki",
        create_location: "Luo sijainti",
        create_project: "Luo projekti",
        create_qr_code: "Luo QR-koodi",
        create_review: "Luo Arvostelu",
        create_review_page: "Luo Arvostelusivu",
        create_signature: "Luo allekirjoitus",
        create_source: "Luo lähde",
        create_space: "Luo työtila",
        create_tag: "Luo Tag",
        create_tag_rule: "Luo Tag",
        create_webhook: "Luo webhookki",
        create_widget: "Luo widget",
        crms: "CRM-järjestelmät",
        csv: "CSV",
        currency: "Valuutta",
        current_plan: "Nykyinen suunnitelma",
        current_year: "Kuluva vuosi",
        custom_field: "Mukautettu kenttä",
        custom_instructions: "Mukautetut ohjeet",
        custom_url: "Mukautettu URL osoite",
        customer: "Asiakas",
        customer_name_convention: "Asiakkaan nimeämiskäytäntö",
        customer_reviews: "Arvostelut",
        customers: "Asiakkaat",
        customize: "Mukauta",
        customize_review_page: "Mukauta Arvostelusivu",
        daily: "Päivittäin",
        daily_email_requests: "Päivittäiset sähköpostipyynnöt",
        daily_limit: "Päivittäinen raja",
        daily_requests: "Päivittäiset pyynnöt",
        daily_sms_requests: "Päivittäiset tekstiviestipyynnöt",
        dark: "Tumma",
        dashboard: "Kojelauta",
        date: "Päivämäärä",
        date_added: "Lisäyspäivämäärä",
        date_canceled: "Peruutuspäivämäärä",
        date_clicked: "Klikkauspäivämäärä",
        date_complained: "Valituspäivämäärä",
        date_delivered: "Toimituspäivämäärä",
        date_failed: "Päivämäärä epäonnistui",
        date_messaged: "Viestin päivämäärä",
        date_opened: "Avauspäivämäärä",
        date_replied: "Vastauspäivämäärä",
        date_requested: "Pyydetty päivämäärä",
        date_reviewed: "Arvosteltu",
        date_scheduled: "Aikataulun mukainen päivämäärä",
        date_sent: "Lähetyspäivämäärä",
        date_signed_up: "Rekisteröitymispäivämäärä",
        date_updated: "Päivityspäivämäärä",
        dates: "Päivämäärät",
        day: "Päivä",
        days: "Päivät",
        days_after_last_request: "päivää viimeisen pyynnön jälkeen",
        days_later: "päivää myöhemmin",
        deactivate: "Deaktivoi",
        default: "Oletus",
        default_language: "Oletuskieli",
        default_review_page: "Arvostelusivu",
        default_review_visibility: "Arvostelu näkyvyys",
        default_tone: "Oletusääni",
        delay: "Viive",
        delete: "Poista",
        delete_1_customer: "Poista 1 asiakas",
        delete_1_review: "Poista 1 Arvostelu",
        delete_1_review_page: "Poista 1 Arvostelusivu",
        delete_1_widget: "Poista 1 widget",
        delete_agency: "Poista toimisto",
        delete_custom_field: "Poista mukautettu kenttä",
        delete_customer: "Poista asiakas",
        delete_customers: "Poista asiakkaat",
        delete_external_link: "Poista ulkoinen Linkki",
        delete_field: "Poista kenttä",
        delete_link: "Poista Linkki",
        delete_location: "Poista sijainti",
        delete_message: "Poista viesti",
        delete_n_customers: "Poista {count} asiakkaat",
        delete_n_review_pages: "Poista {count} Arvostelusivut",
        delete_n_reviews: "Poista {count} Arvostelut",
        delete_n_widgets: "Poista {count} Widgetit",
        delete_project: "Poista projekti",
        delete_qr_code: "Poista QR-koodi",
        delete_reply: "Poista vastaus",
        delete_review: "Poista Arvostelu",
        delete_review_page: "Poista Arvostelusivu",
        delete_review_pages: "Poista Arvostelusivut",
        delete_reviews: "Poista Arvostelut",
        delete_signature: "Poista Allekirjoitus",
        delete_source: "Poista lähde",
        delete_space: "Poista työtila",
        delete_tag: "Poista Tag",
        delete_tag_rule: "Poista Tag",
        delete_template: "Poista mallipohja",
        delete_user: "Poista käyttäjä",
        delete_webhook: "Poista webhook",
        delete_widget: "Poista widget",
        delete_widgets: "Poista widgetit",
        deleted: "Poistettu",
        delivered: "Toimitettu",
        description: "Kuvaus",
        deselect_all: "Poista kaikkien valinta",
        disable: "Poista käytöstä",
        disable_automatic_review_collection: "Poista automaattinen Arvostelu kerääminen käytöstä",
        disable_field: "Poista kenttä käytöstä",
        disable_when_links_are_visible: "Poista käytöstä, kun linkit ovat näkyvissä",
        disabled: "Poissa käytöstä",
        disconnect: "Katkaise yhteys",
        disconnect_integration: "Katkaise integraatio",
        discord_community: "Discord-yhteisö",
        display_name: "Näyttönimi",
        dmarc: "DMARC",
        dmarc_status_for: "DMARC-tila kohteelle",
        do_not_hide_from_public: "Älä piiloudu yleisöltä",
        do_not_send: "Älä lähetä",
        docs: "Dokumentit",
        documentation: "Dokumentaatio",
        domain: "Verkkotunnus",
        domain_name: "Verkkotunnus",
        dont_have_an_account: "Eikö sinulla ole tiliä?",
        dont_send_thanks: "Älä lähetä kiitosta",
        download: "Lataa",
        download_records: "Lataa tiedot",
        download_template: "Lataa mallipohja",
        dpa: "Tietosuoja",
        dsar: "DSAR",
        duplicate: "Kopio",
        duplicate_project: "Kopioi projekti",
        duplicate_review_page: "Kopioi Arvostelusivu",
        duplicate_reviews: "Päällekkäiset Arvostelut",
        duplicate_widget: "Kopioi widget",
        edit: "Muokkaa",
        edit_1_customer: "Muokkaa 1 asiakasta",
        edit_1_review: "Muokkaa 1 Arvostelu",
        edit_client: "Muokkaa Client",
        edit_custom_field: "Muokkaa mukautettua kenttää",
        edit_customer: "Muokkaa asiakasta",
        edit_customers: "Muokkaa asiakkaita",
        edit_field: "Muokkaa kenttää",
        edit_link: "Muokkaa Linkki",
        edit_location: "Muokkaa sijaintia",
        edit_member: "Muokkaa jäsentä",
        edit_n_customers: "Muokkaa {count} asiakkaita",
        edit_n_reviews: "Muokkaa {count} Arvostelut",
        edit_notes: "Muokkaa muistiinpanoja",
        edit_qr_code: "Muokkaa QR-koodia",
        edit_reviews: "Muokkaa Arvostelut",
        edit_signature: "Muokkaa Allekirjoitus",
        edit_source: "Muokkaa lähdettä",
        edit_strategy: "Muokkaa strategiaa",
        edit_tag: "Muokkaa Tag",
        edit_tag_rule: "Muokkaa Tag",
        edit_tags: "Muokkaa tageja",
        edit_team_member: "Muokkaa tiimin jäsentä",
        edit_visibility: "Muokkaa näkyvyyttä",
        edit_webhook: "Muokkaa webhookia",
        editable_ratings: "Muokattavat arvioinnit",
        earned: "Ansaittu",
        eligible: "Kelvollinen",
        email: "Sähköposti",
        email_address: "Sähköpostiosoite",
        email_validation_invalid: "Sähköpostin vahvistus epäonnistui",
        email_validation_passed: "Sähköpostin vahvistus läpäisty",
        email_validation_unknown: "Sähköpostia ei voitu vahvistaa",
        emails: "Sähköpostit",
        embed_code: "Upota koodi",
        enable: "Ota käyttöön",
        enable_automatic_review_collection: "Ota automaattinen Arvostelu kerääminen käyttöön",
        enable_for_all_reviews: "Ota käyttöön kaikissa arvostelut",
        enable_for_positive_reviews: "Ota käyttöön positiivisille arvosteluille",
        enable_on_review_pages: "Ota käyttöön arvostelusivuilla",
        enabled: "Käytössä",
        end: "Loppu",
        ends: "Päättyy",
        exclude: "Sulje pois",
        exclude_email: "Sähköpostin poissulkeminen",
        exclude_sms: "Sulje pois tekstiviestit",
        excluded_channels: "Poissuljetut kanavat",
        expand: "Laajenna",
        expired: "Vanhentunut",
        export: "Vie",
        export_1_customer: "Vie 1 asiakas",
        export_1_review: "Vie 1 Arvostelu",
        export_all: "Vie kaikki",
        export_all_customers: "Vie kaikki asiakkaat",
        export_all_reviews: "Vie kaikki Arvostelut",
        export_customers: "Vientiasiakkaat",
        export_n_customers: "Vie {count} Asiakkaat",
        export_n_reviews: "Vie {count} Arvostelut",
        export_reviews: "Arvostelut",
        external_link: "Ulkoinen Linkki",
        external_links: "Ulkoiset Linkit",
        extra_locations: "Lisäsijainnit",
        faces: "Kasvot",
        failed: "Epäonnistui",
        feedback: "Palaute",
        field: "Ala",
        fields: "Kentät",
        filter: "Suodattaa",
        first: "Ensimmäinen",
        first_charged: "Ensimmäinen veloitus",
        first_name: "Etunimi",
        first_name_last_initial: "Etunimi, Sukunimi (alkukirjain)",
        flag_as_duplicate: "Merkitse kaksoiskappaleeksi",
        font: "Fontti",
        font_family: "Fonttiperhe",
        font_size: "Fonttikoko",
        footer: "Alatunniste",
        for: "Sillä",
        forgot_password: "Unohtunut salasana",
        form: "Lomake",
        free: "Ilmainen",
        free_requests_included: "Ilmaiset pyynnöt sisältyvät hintaan",
        from: "alkaen",
        full_name: "Koko nimi",
        generate: "Luo",
        generate_meta: "Luo metatiedot",
        generate_qr_code: "Luo QR-koodi",
        generate_reply: "Luo vastaus",
        generate_review: "Luo Arvostelu",
        generating: "Luodaan",
        get_started: "Aloita",
        get_started_checklist: "Aloituslista",
        get_the_lifetime_deal: "Hanki elinikäinen tarjous",
        getting_started: "Aloittaminen",
        google_fonts: "Google-fontit",
        grouped_by_request: "Ryhmitelty pyynnön mukaan",
        has_links: "Sisältää Linkit",
        has_notes: "Sisältää muistiinpanoja",
        has_redirects: "Sisältää uudelleenohjauksia",
        have_an_account: "Onko sinulla tili?",
        header: "Ylätunniste",
        hidden: "Piilotettu",
        hidden_from_search_engines: "Piilotettu hakukoneilta",
        hidden_reviews: "Piilotetut Arvostelut",
        hide: "Piilota",
        hide_all_reviews: "Piilota kaikki arvostelut",
        hide_avatar: "Piilota avatar",
        hide_date: "Piilota päivämäärä",
        hide_drop_shadow: "Piilota varjo",
        hide_field_label: "Piilota kentän otsikko",
        hide_from_public: "Piilota yleisöltä",
        hide_name: "Piilota nimi",
        hide_pagination: "Piilota sivutus",
        highlight_color: "Korostusväri",
        hipaa: "HIPAA",
        host: "Isäntä",
        hours: "Tunnit",
        icon: "Kuvake",
        icon_size: "Kuvakkeen koko",
        icons: "Kuvakkeet",
        id: "ID",
        image: "Kuva",
        import: "Tuo",
        import_address1: "Asiakkaan osoiterivi 1.",
        import_address2: "Asiakkaan osoiterivi 2.",
        import_city: "Asiakkaan kaupunki tai paikkakunta.",
        import_company: "Asiakkaan yrityksen nimi.",
        import_created_at: "Arvioinnin päivämäärä.",
        import_customers: "Tuo asiakkaita",
        import_email: "Asiakkaan sähköpostiosoite.",
        import_first_name: "Asiakkaan etunimi.",
        import_from_boost_space: "Tuo Boost.space sivustolta",
        import_from_hubspot: "Tuo HubSpot",
        import_from_make_com: "Tuo Make.com",
        import_from_pabbly: "Tuo Pabbly",
        import_from_stripe: "Tuo Stripe",
        import_from_zapier: "Tuo Zapier",
        import_last_name: "Asiakkaan sukunimi.",
        import_list: "Pilkuilla erotettu luettelo",
        import_notes: "Vain sisäiseen käyttöön.",
        import_phone: "Asiakkaan puhelinnumero.",
        import_postal_code: "Asiakkaan postinumero.",
        import_recent_reviews: "Tuo viimeisimmät Arvostelut",
        import_review: "Arvostelun teksti.",
        import_reviews: "Tuo Arvostelut",
        import_score: "Arvosana asteikolla 1-5.",
        import_signed_up_at: "Asiakkaan aloituspäivämäärä.",
        import_slug: "etana tai UUID",
        import_state: "Asiakkaan osavaltio tai alue.",
        import_yourself: "Tuo itsesi",
        incentive: "Kannustin",
        include: "Sisällytä",
        include_sample_reviews: "Sisällytä arvostelut",
        incoming_webhook_url: "Saapuvan webhookin URL-osoite",
        inherit: "Periä",
        initializing: "Alustaminen",
        initials: "Nimikirjaimet",
        install_in: "Asenna sisään",
        insert_variable: "Lisää muuttuja",
        instructions: "Ohjeet",
        integration: "Integraatio",
        integrations: "Integraatiot",
        interval: "Väli",
        introduction: "Johdanto",
        invite: "Kutsu",
        invite_client: "Kutsu Client",
        invite_failed: "Kutsu epäonnistui",
        invite_member: "Kutsu jäsen",
        invite_sent_to: "Kutsu lähetetty",
        invite_team_member: "Kutsu tiimin jäsen",
        invited: "Kutsuttu",
        issuer_url: "Issuer-URL",
        italic: "Kursiivi",
        joined: "Liittynyt",
        key: "Avain",
        keywords: "Avainsanat",
        keywords_in_replies: "Avainsanat vastauksissa",
        keywords_in_reviews: "Avainsanat arvosteluissa",
        kiosk_page: "Kioskisivu",
        label: "Tarra",
        label_font_size: "Otsikon fonttikoko",
        labels: "Tarrat",
        language: "Kieli",
        languages: "Kielet",
        large: "Suuri",
        last_charged: "Viimeksi veloitettu",
        last_name: "Sukunimi",
        layout: "Layout",
        leave: "Lähtö",
        leave_project: "Poistu projektista",
        leave_space: "Jätä Työtila",
        left: "Vasen",
        let_clients_sign_in_with_sso: "Anna asiakkaiden kirjautua SSO:lla",
        less: "Vähemmän",
        lifecycle_stage: "Elinkaaren vaihe",
        lifetime_deal: "Elinikäinen tarjous",
        light: "Valo",
        limit: "Rajoittaa",
        limits: "Rajat",
        link: "Linkki",
        link_color: "Linkin väri",
        link_reveal_position: "Linkki paljastamissijainti",
        link_revealer_button: "Linkki paljastaja Painike",
        link_revealer_label: "Linkki paljastajan otsikko",
        link_revealer_rating: "Linkki paljastajan luokitus",
        links: "Linkit",
        links_per_review_page: "Linkit Arvostelusivu",
        list: "Lista",
        list_unsubscribe_headers: "Listan tilauksen peruutusotsikot",
        load_more: "Lataa lisää",
        loading: "Ladataan",
        location: "Sijainti",
        location_address: "Sijaintiosoite",
        location_name: "Sijainnin nimi",
        location_picker: "Sijainnin valitsin",
        locations: "Sijainnit",
        locations_limit: "Sijaintirajoitus",
        log_in: "Kirjaudu sisään",
        log_out: "Kirjaudu ulos",
        logo: "Logo",
        logo_height: "Logon korkeus",
        long: "Pitkä",
        lowest_rating: "Alin luokitus",
        ltd: "LTD",
        make_default: "Aseta oletukseksi",
        manage: "Hallitse",
        manage_limits: "Hallitse rajoja",
        manage_overrides: "Hallinnoi ohituksia",
        manage_payout_account: "Hallinnoi maksutiliä",
        manage_subscription: "Hallinnoi tilausta",
        manual_entry: "Manuaalinen syöttö",
        max: "Maksi",
        max_size: "Maksimikoko",
        maximum_characters: "Merkkiä enimmäismäärä",
        maximum_customers: "Eniten asiakkaita",
        maximum_locations: "Maksimisijainnit",
        maximum_members: "Jäsenten enimmäismäärä",
        maximum_review_length: "Arvostelu enimmäispituus",
        maximum_tags: "Enimmäismäärä Tagit",
        maximum_widgets: "Enimmäismäärä widgettejä",
        mcp: "MCP Palvelin",
        mcp_server: "MCP Palvelin",
        mcp_server_url: "MCP Palvelin URL",
        medium: "Keskikokoinen",
        member: "Jäsen",
        members: "Jäsenet",
        menu: "Valikko",
        message: "Viesti",
        message_link_expiration: "Linkki vanheneminen",
        messaged: "Viestitetty",
        messages: "Viestit",
        messages_clicked: "Klikatut viestit",
        messages_sent: "Lähetetyt viestit",
        messaging_service_sid: "Viestipalvelun SID",
        min: "Minimi",
        min_size: "Minimikoko",
        minimal_delay: "Minimaalinen viive",
        minimum_characters: "Merkkiä",
        minutes: "Minuutit",
        month: "kuukausi",
        monthly: "Kuukausittain",
        monthly_email_requests: "Kuukausittaiset sähköpostipyynnöt",
        monthly_limit: "Kuukausittainen raja",
        monthly_pricing_only: "Vain kuukausihinnoittelu",
        monthly_request_limit: "Kuukausittainen pyyntöraja",
        monthly_requests: "Kuukausittaiset pyynnöt",
        monthly_sms_requests: "Kuukausittaiset tekstiviestipyynnöt",
        months: "Kuukaudet",
        months_free: "{count} Kuukautta ilmaiseksi",
        more: "lisää",
        more_clients: "enemmän asiakkaita",
        more_customers: "enemmän asiakkaita",
        more_options: "Lisää vaihtoehtoja",
        more_patients: "enemmän potilaita",
        more_reviews: "lisää arvostelut",
        more_reviews_needed: "Yhteenvetoon tarvitaan lisää arvostelut",
        more_users: "enemmän käyttäjiä",
        more_visitors: "enemmän kävijöitä",
        most_negative: "Negatiivisimmat",
        most_positive: "Positiivisimmat",
        move: "Liikkua",
        moved: "Siirretty",
        name: "Nimi",
        native_reviews: "Arvostelut",
        negative_term: "Negatiivinen termi",
        negative_trends: "Negatiiviset trendit",
        new: "Uusi",
        new_password: "Uusi salasana",
        newest: "Uusimmat",
        no: "Ei",
        no_available_options: "Ei saatavilla olevia vaihtoehtoja",
        no_credit_card_required: "Luottokorttia ei tarvita",
        no_data_available: "Ei tietoja saatavilla",
        no_negative_trends: "Ei vielä negatiivisia trendejä",
        no_positive_trends: "Ei vielä positiivisia trendejä",
        no_reminders: "Älä lähetä muistutuksia",
        no_retries: "Ei uudelleenyrityksiä",
        no_review: "Ei arvostelua",
        none: "Ei mitään",
        not_connected: "Ei yhteyttä",
        not_reviewed: "Ei Arvosteltu",
        notes: "Muistiinpanoja",
        notifications: "Ilmoitukset",
        now: "Nyt",
        n_1_ai_tag: "1 tekoälytagi",
        n_1_review_page: "1 arvostelusivu",
        n_ai_tags: "{count} tekoälytagia",
        n_review_pages: "{count} arvostelusivua",
        number_of_charges: "Maksujen määrä",
        number_of_reminders: "Muistutusten määrä",
        number_of_retries: "Uudelleenyritysten määrä",
        number_of_review_suggestions: "Arvostelu määrä",
        of: "jostakin",
        off: "Pois",
        on: "Päällä",
        on_for_positive_reviews: "Päällä myönteisille arvosteluille",
        on_channel: "kanavalla {channel}.",
        opened: "Avattu",
        options: "Asetukset",
        or_log_in_with_email: "tai kirjaudu sisään sähköpostiosoitteellasi",
        or_sign_up_with_email: "tai käytä sähköpostiosoitettasi",
        our_reviews: "Arvostelut",
        output: "Lähtö",
        page_footer: "Sivun alatunniste",
        paid: "Maksettu",
        paragraph: "Kohta",
        password: "Salasana",
        past_month: "Viime kuukausi",
        past_months: "Viimeiset {inc} kuukautta",
        past_week: "Viime viikko",
        past_year: "Viime vuonna",
        past_years: "Viimeiset {inc} vuotta",
        paused: "Keskeytetty",
        payment_method: "Maksutapa",
        payout_status_completed: "Valmis",
        payout_status_pending: "Odottaa",
        pending: "Odottaa",
        pending_deployment: "Odottaa käyttöönottoa",
        pending_validation: "Odottaa vahvistusta",
        per_day: "päivässä",
        per_month: "kuukaudessa",
        permissions: "Käyttöoikeudet",
        phone: "Puhelin",
        phone_number: "Puhelinnumero",
        pixels: "pikseliä",
        placeholder: "Paikkamerkki",
        placement: "Sijoittelu",
        plan: "Suunnitelma",
        plan_bullet1: "Poista brändäyksemme sähköposteista, sivuilta ja widgeteistä",
        plan_bullet2: "Käytä verkkotunnustasi asiakkaille suunnattuihin sivuihin ja sähköpostien lähettämiseen",
        plan_bullet3: "Tee tuotteesta omasi white label -ratkaisulla toimistoille",
        please_rate_our_service: "Arvioi palvelumme",
        png: "PNG",
        policies: "Käytännöt",
        popular: "Suosittu",
        port: "Portti",
        position: "Sijainti",
        positive_only: "Vain positiivisia Arvostelut",
        positive_term: "Positiivinen termi",
        positive_trends: "Positiiviset trendit",
        powered_by: "Powered by",
        preview: "Esikatselu",
        preview_kiosk_page: "Esikatsele kioskisivua",
        preview_review_page: "Esikatsele Arvostelusivu",
        price: "Hinta",
        pricing: "Hinnoittelu",
        primary_color: "Ensisijainen väri",
        priority: "Prioriteetti",
        privacy_policy: "Tietosuojakäytäntö",
        proceed_to_dashboard: "Siirry Kojelauta",
        product: "Tuote",
        profile: "Profiili",
        project: "Projekti",
        project_name: "Projektin nimi",
        setup_ask_delay: "Kuinka kauan odottaa ennen arvostelun pyytämistä",
        setup_reminders: "Kuinka monta muistutusta lähetetään",
        project_paused: "Tämä projekti on keskeytetty.",
        project_suspended: "Tämä projekti on keskeytetty.",
        project_website: "Projektin verkkosivusto",
        projects: "Projektit",
        projects_limit: "Projektien raja",
        publish: "Julkaise",
        publish_changes: "Julkaise muutokset kaikille muille Arvostelusivuille",
        published: "Julkaistu",
        purchase: "Osta",
        qr_code: "QR-koodi",
        qr_code_name_placeholder: "Pöytä 1, Vastaanotto",
        qr_codes: "QR-koodit",
        quantity: "Määrä",
        query: "Kysely",
        quick_import: "Pikatuonti",
        rating: "Arvosana",
        rating_order: "Arviointijärjestys",
        rating_out_of: "luokitus pisteistä",
        rating_save_all: "Tallenna arvio ennen jokaista arvostelua",
        rating_save_customer: "Tallenna arvio ennen asiakasarvostelua",
        rating_save_never: "Älä koskaan tallenna arvosanaa ennen arvostelua",
        rating_selection: "Luokituksen valinta",
        rating_selector: "Arviointivalitsin",
        ratings: "Arviot",
        read: "Lue",
        reapply_highlights_eligible: "Luo uudelleen kohokohdat tekoälyn avulla kaikista positiivisista arvostelut",
        reconnect: "Yhdistä uudelleen",
        redeem: "Lunasta",
        redirect_uri: "Uudelleenohjauksen URI",
        redirects: "Uudelleenohjaukset",
        refer_and_earn: "Suosittele ja ansaitse",
        referral_billing_status_active: "Tilattu",
        referral_billing_status_canceled: "Peruutettu",
        referral_billing_status_trial: "Kokeilu",
        referral_billing_status_trial_expired: "Kokeilujakso päättyi",
        referral_billing_status_trial_expiring: "Kokeilujakso päättyy",
        referral_program: "Suositteluohjelman ehdot",
        referral_program_terms: "Suositteluohjelman ehdot",
        referrals: "Suositukset",
        refresh: "Päivitä",
        regenerate: "Uudelleenluo",
        reject_all: "Hylkää kaikki",
        related_reviews: "Samankaltaisia Arvostelut",
        related_similarity: "Samankaltaisuus",
        remaining: "Jäljellä",
        reminder: "Muistutus",
        reminders: "Muistutukset",
        remove: "Poista",
        remove_client: "Poista Client",
        remove_cname: "Poista CNAME",
        remove_domain: "Poista verkkotunnus",
        remove_from_project: "Poista projektista",
        remove_member: "Poista jäsen",
        remove_smtp_configuration: "Poista SMTP -määritykset",
        remove_team_member: "Poista tiimin jäsen",
        rename: "Nimeä uudelleen",
        rename_template: "Nimeä mallipohja uudelleen",
        renews: "Uudistaa",
        replied: "Vastattu",
        reply: "Vastaa",
        reply_to: "Vastausosoite",
        replying_on: "Vastataan osoitteeseen",
        request: "Pyyntö",
        request_1_review: "Pyydä 1 arvostelu",
        request_date: "Pyyntöpäivämäärä",
        request_n_reviews: "Pyydä {count} arvostelua",
        request_review: "Pyydä Arvostelu",
        request_reviews: "Pyydä Arvostelut",
        requested: "Pyydetty",
        requested_review: "Pyydetty Arvostelu",
        requests: "Pyynnöt",
        requests_left_this_month: "pyyntöjä jäljellä tässä kuussa",
        requests_remaining: "Jäljellä olevat pyynnöt",
        require_field: "Pakollinen kenttä",
        require_sso: "Vaadi kertakirjautuminen",
        required: "Pakollinen",
        reschedule_message: "Ajoita viesti uudelleen",
        resend_invite: "Lähetä kutsu uudelleen",
        reset_password: "Palauta salasana",
        restore: "Palauttaa",
        restore_to_defaults: "Palauta oletusarvot",
        restore_widget: "Palauta widget",
        resubscribe: "Tilaa uudelleen",
        resubscribe_customer: "Tilaa asiakas uudelleen",
        resync: "Synkronoi uudelleen",
        resync_account: "Synkronoi tili uudelleen",
        resync_now: "Synkronoi uudelleen nyt",
        retries: "Uudelleenyritykset",
        reveal_above_form: "Näytä yllä oleva lomake",
        reveal_after_submission: "Paljasta lähetyksen jälkeen",
        reveal_below_form: "Näytä lomakkeen alla",
        review: "Arvostelu",
        review_length: "Arvostelu pituus",
        review_link: "Arvostelulinkki",
        review_missed: "Arvostelu ohitettu",
        review_not_requested: "Arvostelu ei pyydetty",
        review_origin: "Tämä arvostelu on peräisin mallista",
        review_page: "Arvostelusivu",
        review_pages: "Arvostelusivut",
        review_requested: "Arvostelupyyntö lähetetty",
        review_spotlight: "Arvostelunosto",
        review_suggestion: "Arvosteluehdotus",
        review_suggestions: "Arvosteluehdotukset",
        review_text: "Arvostelun teksti",
        review_wall: "Arvosteluseinä",
        reviewed: "Arvosteltu",
        reviews: "Arvostelut",
        reviews_ask: "Pyydä",
        reviews_query_failed: "Jotain meni pieleen. Yritä uudelleen.",
        reviews_query_placeholder: "Hae arvostelut tai kysy kysymys...",
        reviews_with_highlights: "Arvostelut kohokohdineen",
        reviews_with_replies: "Arvostelut vastauksilla",
        reviews_without_replies: "Arvostelut ilman vastauksia",
        revoke: "Peruuta käyttöoikeus",
        revoke_client: "Peruuta sovellus",
        roadmap: "Etenemissuunnitelma",
        role: "Rooli",
        sans_serif: "Sans Serif",
        save: "Tallenna",
        save_preferences: "Tallenna asetukset",
        save_template: "Tallenna mallipohja",
        save_template_as_new: "Tallenna uusi mallipohja",
        saved: "Tallennettu",
        schedule: "Ajoittaa",
        schedule_review_request: "Aikatauluta arvostelupyyntö",
        scheduled: "Ajoitettu",
        score: "Pisteet",
        search: "Haku",
        second: "Toinen",
        secret_key: "Salainen avain",
        sections: "Osiot",
        security_code: "Turvakoodi",
        select: "Valitse",
        select_account: "Valitse tili",
        select_all: "Valitse kaikki",
        select_an_option: "Valitse vaihtoehto",
        select_bulk_action: "Valitse joukkotoiminto",
        select_csv_file: "Valitse CSV-tiedosto",
        select_date: "Valitse päivämäärä",
        select_field: "Valitse kenttä",
        select_icon: "Valitse kuvake",
        select_location: "Valitse sijainti",
        select_plan: "Valitse paketti",
        select_review: "Valitse Arvostelu",
        select_source: "Valitse lähde",
        select_tag: "Valitse Tag",
        selected: "Valittu",
        send: "Lähetä",
        send_1_reminder: "Lähetä 1 muistutus",
        send_2_reminders: "Lähetä 2 muistutusta",
        send_3_reminders: "Lähetä 3 muistutusta",
        send_anytime: "Lähetä milloin tahansa",
        send_between: "Lähetä välillä",
        send_message: "Lähetä viesti",
        send_retries: "Lähetä {count} uudelleenyrityksiä",
        send_retry: "Lähetä {count} Yritä uudelleen",
        send_test: "Lähetä testi",
        send_thanks: "Lähetä kiitos",
        sender_email_address: "Lähettäjän sähköpostiosoite",
        sender_id: "Lähettäjän tunnus",
        sender_name: "Lähettäjän nimi",
        sending_domain: "Lähettävä verkkotunnus",
        sentiment: "Tunne",
        sent: "Lähetetty",
        sent_replies: "Lähetetyt vastaukset",
        serif: "Serif",
        set_up: "Ota käyttöön",
        settings: "Asetukset",
        share: "Jaa",
        share_link: "Jaa Linkki",
        short: "Lyhyt",
        show: "Show",
        show_1_suggestion: "Näytä 1 ehdotus",
        show_100_results: "Näytä 100 tulosta",
        show_2_suggestions: "Näytä 2 ehdotusta",
        show_25_results: "Näytä 25 tulosta",
        show_3_suggestions: "Näytä 3 ehdotusta",
        show_4_suggestions: "Näytä 4 ehdotusta",
        show_5_suggestions: "Näytä 5 ehdotusta",
        show_50_results: "Näytä 50 tulosta",
        show_all_reviews: "Näytä kaikki arvostelut",
        show_arrows: "Näytä nuolet",
        show_avatar: "Näytä avatar",
        show_cookie_consent_banner: "Näytä evästeiden suostumusbanneri",
        show_date: "Näytä päivämäärä",
        show_dots: "Näytä pisteet",
        show_drop_shadow: "Näytä varjo",
        show_field: "Näytä kenttä seuraavissa arvioinneissa",
        show_full: "Näytä täydet tähdet",
        show_photo: "Näytä vain valokuva",
        show_positive_reviews: "Näytä vain positiiviset arvostelut",
        show_to_public: "Näytä yleisölle",
        showcase: "Showcase",
        showcase_page: "Showcasesivu",
        sign_up: "Rekisteröidy",
        sign_up_for_free: "Rekisteröidy ilmaiseksi",
        sign_up_with_email: "Rekisteröidy sähköpostilla",
        sign_in_with_sso: "Kirjaudu sisään kertakirjautumisella",
        sign_up_with_google: "Rekisteröidy Googlella",
        signature: "Allekirjoitus",
        signatures: "Allekirjoitukset",
        signed_up: "Rekisteröitynyt",
        since: "Alkaen",
        size: "Koko",
        skip: "Ohita",
        slug: "Slug",
        small: "Pieni",
        sms: "SMS",
        smtp_configuration: "SMTP-konfiguraatio",
        sort: "Järjestellä",
        source: "Lähde",
        source_code: "Lähdekoodi",
        sources: "Lähteet",
        space: "Työtila",
        space_name: "Tila nimi",
        spaces: "Työtilat",
        split: "Jaa",
        sso: "SSO",
        star_color: "Tähden väri",
        stars: "Tähdet",
        start: "Aloita",
        start_free_trial: "Aloita ilmainen kokeilu",
        start_getting_more_reviews: "Hanki lisää Arvostelut",
        status: "Status",
        store_code: "Myymälän koodi",
        strategy: "Strategia",
        sub_processors: "Alikäsittelijät",
        subject: "Aihe",
        subscribe: "Tilaa",
        subscription: "Tilaus",
        success_page: "Menestyssivu",
        suggestion: "Ehdotus",
        suggestions: "Ehdotukset",
        summary: "Yhteenveto",
        support: "Tuki",
        suspend: "Keskeytä",
        suspend_project: "Keskeytä projekti",
        suspended: "Keskeytetty",
        svg: "SVG",
        switch_to_smtp_setup: "Vaihda SMTP-asetuksiin",
        switch_to_standard_setup: "Vaihda vakioasetuksiin",
        symbol: "Symboli",
        sync: "Synkronoi",
        sync_account: "Synkronoi tili",
        sync_now: "Synkronoi nyt",
        sync_scheduled_time: "Synkronointi ajoitettu {time}",
        sync_with_facebook: "Synkronoi Facebookin kanssa",
        sync_with_google: "Synkronoi Googlen kanssa",
        synced_time: "Synkronoitu {time}",
        system: "Järjestelmä",
        system_fonts: "Järjestelmäfontit",
        tag: "Tag",
        tag_1_customer: "Tag 1 Asiakas",
        tag_1_review: "Tag 1 Arvostelu",
        tag_customers: "Merkitse asiakkaat",
        tag_existing_reviews: "Tag olemassa olevat Arvostelut",
        tag_n_customers: "Tag {count} Asiakkaat",
        tag_n_reviews: "Tag {count} Arvostelut",
        tag_reviews: "Merkitse arvostelut",
        tag_rule: "Tag sääntö",
        tag_with_ai: "Tag tekoälyllä",
        tags: "Tagit",
        tags_for_customers: "Asiakkaiden Tagit",
        tags_for_reviews: "Arvostelut Tagit",
        team: "Joukkue",
        team_member: "Tiimin jäsen",
        team_members: "Tiimin jäsenet",
        template: "Mallipohja",
        templates: "Mallit",
        terms_of_service: "Palveluehdot",
        test_template: "Testimalli",
        tests: "Testit",
        text: "Teksti",
        text_alignment: "Tekstin tasaus",
        text_color: "Tekstin väri",
        thank_you_messages: "Kiitosviestit",
        thanks: "Kiitos",
        theme: "Teema",
        third: "Kolmas",
        time_zone: "Aikavyöhyke",
        timeframe: "Aikataulu",
        title: "Otsikko",
        tone: "Sävy",
        top: "Yläosa",
        top_left: "Vasen yläkulma",
        top_right: "Ylhäällä oikealla",
        total_charges: "Veloitukset yhteensä",
        total_reviews: "Arvostelut yhteensä",
        trigger: "Laukaisin",
        trigger_charged: "Lähetä pyyntö veloituksen jälkeen",
        trigger_created: "Lähetä pyyntö rekisteröitymisen jälkeen",
        try_free: "Kokeile ilmaiseksi",
        try_it_free: "Kokeile ilmaiseksi",
        type: "Tyyppi",
        types: "Tyypit",
        unarchive: "Poista arkistosta",
        unarchive_customer: "Poista asiakkaan arkisto",
        underline: "Korostaa",
        unflag_as_duplicate: "Poista kaksoiskappale-merkintä",
        unknown: "Tuntematon",
        unlimited: "rajoittamaton",
        unnamed: "Nimeämätön",
        unpublish: "Peruuta julkaisu",
        unpublished: "Julkaisematon",
        unreplied: "Vastaamaton",
        unsent_messages: "Lähettämättömät viestit",
        unsubscribe: "Peruuta tilaus",
        unsubscribe_1_customer: "Peruuta 1 asiakkaan tilaus",
        unsubscribe_customer: "Peruuta tilaus Asiakas",
        unsubscribe_customers: "Peruuta tilaus Asiakkaat",
        unsubscribe_n_customers: "Peruuta {count} asiakkaan tilaus",
        unsubscribe_text: "Peruuta tilaus tekstiviestillä",
        unsubscribed: "Tilauksen peruuttanut",
        unsuspend: "Poista jäädytys",
        unsuspend_project: "Poista projektin keskeytys",
        unverified: "Vahvistamaton",
        update: "Päivittää",
        update_password: "Päivitä salasana",
        update_plan: "Päivityssuunnitelma",
        update_share_template: "Päivitä mallipohja",
        updated: "Päivitetty",
        updates: "Päivitykset",
        upgrade: "Päivitä",
        upgrade_for_more: "Päivitä saadaksesi lisää",
        upgrade_to_use: "Päivitä käyttääksesi tätä ominaisuutta",
        upload: "Lataa",
        upload_csv: "Lähetä CSV-tiedosto",
        upload_icon: "Lataa kuvake",
        url: "URL",
        use: "Käyttää",
        use_filters_for_aggregate: "Käytä suodattimia koosteissa",
        user: "Käyttäjä",
        user_id: "Käyttäjätunnus",
        user_info: "Käyttäjätiedot",
        username: "Käyttäjätunnus",
        utc: "UTC",
        validate: "Vahvista",
        validate_customer_email: "Vahvista asiakkaan sähköpostiosoite",
        validation: "Validointi",
        validations: "Vahvistukset",
        value: "Arvo",
        verify: "Vahvista",
        verify_email_address: "Vahvista sähköpostiosoite",
        view: "Näytä",
        view_all: "Näytä kaikki",
        view_all_features: "Näytä kaikki ominaisuudet",
        view_available_fields: "Näytä käytettävissä olevat kentät",
        view_documentation: "Katso dokumentaatio",
        view_email_templates: "Näytä sähköpostimallit",
        view_review_pages: "Näytä Arvostelusivut",
        view_reviews: "Näytä Arvostelut",
        view_settings: "Näytä asetukset",
        view_setup_guide: "Näytä asennusopas",
        view_showcase: "Näytä esittely",
        view_strategy: "Näytä strategia",
        visibility: "Näkyvyys",
        visible: "Näkyvä",
        visible_reviews: "Näkyvät Arvostelut",
        visible_to_search_engines: "Näkyy hakukoneille",
        wait_between_reminders: "Odota muistutusten välillä",
        wait_period: "Odotusaika",
        webhook: "Webhook",
        webhooks: "Webhookit",
        website: "Verkkosivusto",
        weekly: "Viikoittain",
        weeks: "Viikot",
        widget: "Widget",
        widgets: "Widgetit",
        with_ai: "tekoälyn avulla",
        worst_to_best: "Pahimmasta parhaaseen",
        write: "Kirjoittaa",
        written_reviews: "Kirjalliset Arvostelut",
        year: "vuosi",
        yearly: "Vuosittain",
        yes: "Kyllä",
        your_referral_link: "Linkki"
    },
    landing: {
        announcement: "Hanki maine-raportteja MCP-palvelimellamme",
        counter: "Liity yli 5 000 paikallisen palveluyrityksen joukkoon",
        counter_agencies: "Käytössä yli 500 toimistolla arvostelujen hallintaan",
        counter_ai: "Hallitse mainetta Claude ja ChatGPT avulla",
        ai_screen_1_badge: "MCP",
        ai_screen_1_bullets: [
            "Saat vastauksia kirjautumatta toiseen hallintapaneeliin",
            "Toimi maineen perusteella tiimisi jo avaamissa chat-työkaluissa",
            "Tallenna tunteja joka viikko kysymällä kaivamisen sijaan"
        ],
        ai_screen_1_subtitle: "Mainetyösi tulisi vastata kysymyksiin siellä, missä jo ajattelet. Kysy Claude tai ChatGPT: ltä, mihin haluat vastauksen, keneltä kysyä seuraavaksi tai miten viikko meni, ja saat reaaliaikaisia vastauksia vaihtamatta työkalua.",
        ai_screen_1_title: "Kysy Claude tai ChatGPT",
        ai_screen_2_badge: "Tekoälyn vastaukset",
        ai_screen_2_bullets: [
            "Vastaa nopeammin kuulostamatta yleisluontoiselta",
            "Älä koskaan jätä arvostelut vastaamatta, kun olet kiireinen",
            "Suojaa brändisi ääni jokaisessa julkisessa vastauksessa"
        ],
        ai_screen_2_subtitle: "Jokainen vastaamaton arvostelu on menetetty tilaisuus ansaita luottamusta. Tekoäly luonnostelee vastauksia, jotka kuulostavat sinulta, joten voit tyhjentää jonon minuuteissa ja pysyä läsnä asiakkaille ilman kirjoitustyötä.",
        ai_screen_2_title: "Vastaa ilman kiireenseissyä",
        ai_screen_3_badge: "Tekoälyehdotukset",
        ai_screen_3_bullets: [
            "Hanki lisää asiakkaita maaliviivalle",
            "Kerää palautetta, joka on täsmällistä ja jaettavaa",
            "Muuta tyytyväiset vierailut arvostelut arvoisiksi arvosteluiksi"
        ],
        ai_screen_3_subtitle: "Useimmat ihmiset haluavat jättää arvostelun, mutta eivät koskaan tee niin. Kirjoita selkeästi ja omalla äänelläsi, jotta saat viimeisteltyä ja heidän kirjoituksensa on tarpeeksi vahvaa esitettäväksi.",
        ai_screen_3_title: "Hanki lisää 5 tähden arvostelut",
        ai_screen_4_badge: "Tekoälytunnisteet",
        ai_screen_4_bullets: [
            "Havaitse kaavoja ennen kuin niistä tulee ongelmia",
            "Etsi teemoja, jotka todella vaikuttavat arvioihin",
            "Ohita satojen arvostelut lukeminen käsin"
        ],
        ai_screen_4_subtitle: "Sinun ei pitäisi joutua lukemaan jokaista arvostelua uudelleen tietääksesi, mistä on kyse. Tekoäly järjestää palautteen teemoihin, joista välität, joten voit korjata ongelmat nopeammin ja panostaa siihen, mistä asiakkaat pitävät.",
        ai_screen_4_title: "Tiedä, mitä asiakkaat sanovat",
        ai_summary_1_desc: "Luo luonnosvastauksia Google ja Facebookille sävyäsi vastaavasti tai vastaa automaattisesti aikataulun mukaisesti.",
        ai_summary_1_title: "Tekoälyn vastaukset",
        ai_summary_2_desc: "Anna asiakkaille käyttövalmiita arvosteluehdotuksia, kun he jättävät palautetta sivullasi.",
        ai_summary_2_title: "Tekoälyn arviointiehdotukset",
        ai_summary_3_desc: "Mainitse parhaat lauseet positiivisissa arvostelut eri widgeteissä, esittele ja jaa kuvia.",
        ai_summary_3_title: "Tekoälyn kohokohdat",
        ai_summary_4_desc: "Käytä määrittämiesi sääntöjen tagit , jotta teemat, kuten odotusajat tai palvelun laatu, pysyvät järjestyksessä.",
        ai_summary_4_title: "Tekoälyn automaattinen merkitseminen",
        ai_summary_5_desc: "Hanki tiiviitä yhteenvetoja viimeaikaisista arvostelut , joissa on lueteltu lukumääriä, teemoja ja huolenaiheita, joihin kannattaa puuttua.",
        ai_summary_5_title: "Arvostelu",
        ai_summary_6_desc: "Havaitse kasvavaa kiitosta ja esiin nousevia valituksia lukematta jokaista arvostelua käsin.",
        ai_summary_6_title: "Positiiviset ja negatiiviset trendit",
        ai_summary_7_desc: "Etsi samankaltaisia arvostelut palautteen vierestä, jotta kaavat ja toistot on helppo nähdä.",
        ai_summary_7_title: "Aiheeseen liittyvät arvostelut",
        ai_summary_8_desc: "Esitä arvostelut selkokielisiä kysymyksiä ja saat vastauksia avattavilla viitteillä.",
        ai_summary_8_title: "Kysy tekoälystä",
        ai_summary_9_desc: "Yhdistä Claude, ChatGPT ja muut MCP -asiakkaat hallitaksesi mainetta chatissa.",
        ai_summary_9_title: "Avustajien MCP",
        ai_summary_10_desc: "Vedä reaaliaikaisia maineraportteja, jotka kattavat määrän, luokitukset, sijainnit, vastaukset ja yhteydenpidon.",
        ai_summary_10_title: "Maineraportit",
        ai_summary_11_desc: "Opasääni, avainsanat ja mukautetut ohjeet, jotta jokainen tekoälyn tuotos kuulostaa brändiltäsi.",
        ai_summary_11_title: "Bränditietoinen tekoäly",
        ai_summary_12_desc: "Arvioi, kuinka myönteisiltä tai kielteisiltä kirjoitetut arvostelut tuntuvat, tähtiä pidemmälle, ja lajittele huomion arvoiset.",
        ai_summary_12_title: "Tunnesävy",
        industries: {
            accountants: "Kirjanpitäjät",
            auto_repair: "Automekaanikot",
            chiropractors: "Kiropraktikot",
            cleaning: "Siivoojat",
            contractors: "Urakoitsijat",
            dentists: "Hammaslääkärit",
            doctors: "Lääkärit",
            electricians: "Sähköasentajat",
            financial_advisors: "Talousneuvojat",
            hvac: "LVI-teknikot",
            insurance_brokers: "Vakuutusmeklarit",
            landscapers: "Puutarhurit",
            law_firms: "Lakimiehet",
            locksmiths: "Lukkosepät",
            mortgage_brokers: "Asuntolainavälittäjät",
            optometrists: "Optikot",
            personal_trainers: "Henkilökohtaiset valmentajat",
            pest_control: "Tuholaistorjujat",
            physical_therapists: "Fysioterapeutit",
            plumbers: "Putkimiehet",
            real_estate: "Kiinteistönvälittäjät",
            restaurants: "Ravintoloitsijat",
            salons: "Kampaajat",
            self_storage: "Varasto-operaattorit",
            spas: "Kosmetologit",
            tour_guides: "Matkaoppaat",
            veterinarians: "Eläinlääkärit"
        },
        industries_title: "Arvostelujen hallinta paikallisille palveluyrityksille",
        stat_1_article: "Kuluttajatutkimusraportti",
        stat_1_desc: "Ihmiset haluavat yli 100 arvostelut ennen kuin he luottavat verkkoyritykseen.",
        stat_1_source: "Mustajuuri",
        stat_1_title: "Arvostelut ansaitsevat luottamuksen",
        stat_2_article: "Paikallinen Arvostelu",
        stat_2_desc: "Paikallisia yrityksiä vertailevat ostajat suosivat sellaisia, jotka vastaavat jokaiseen arvosteluun.",
        stat_2_source: "KirkasLocal",
        stat_2_title: "Valitse vastaajat",
        stat_3_article: "Arvostelut, maine ja tulot",
        stat_3_desc: "Pienikin arvostelupisteiden nousu voi tarkoittaa todellista parannusta ansioissasi.",
        stat_3_source: "Harvardin kauppakorkeakoulu",
        stat_3_title: "Tuotto tähteä kohden",
        stat_4_article: "Kuluttajien riippuvuus tekoälyn hakutuloksista",
        stat_4_desc: "Kun ihmiset kysyvät tekoälyltä, kenet valita, arvostelut auttavat kirjoittamaan vastauksen.",
        stat_4_source: "Bain & Company",
        stat_4_title: "Luota tekoälyhakuun",
        subtitle: "Pyydä arvostelut automaattisesti. Hanki enemmän viiden tähden arvioita. Sijoitu korkeammalle kuin kilpailijasi.",
        agencies_screen_1_badge: "Portaali",
        agencies_screen_1_bullets: [
            "Myy brändättyä portaalia jokaisella asiakaspalvelijalla",
            "Pidä asiakkaat ekosysteemissäsi, älä kolmannen osapuolen kirjautumistunnuksen kautta",
            "Näytä ohjelmistoyritykseltä, mutta ilman sellaisen rakentamista"
        ],
        agencies_screen_1_subtitle: "Anna jokaiselle asiakkaalle portaali, joka näyttää siltä kuin sinä olisit rakentanut sen: logosi, värit, domainisi. Paketoi sitten arvostelujen hallinta toistuvaksi palveluksi, johon he kirjautuvat joka kuukausi. Et suosittele työkalua. Toimitat sellaisen.",
        agencies_screen_1_title: "Portaali, jonka he luulevat sinun rakentaneen",
        agencies_screen_2_badge: "Ohjaus",
        agencies_screen_2_bullets: [
            "Sovita ominaisuudet aloitus-, kasvu- ja premium-paketteihin",
            "Kutsu oikeat ihmiset ja hallitse, mitä kukin asiakas näkee",
            "Ohita pyynnöt, sijainnit ja rajoitukset projektikohtaisesti"
        ],
        agencies_screen_2_subtitle: "Kaikkien asiakkaiden ei tarvitse saada kaikkea. Kutsu tiimejä tiettyihin projekteihin, aseta rooleja ja ohita ominaisuuksia sekä rajoja tilikohtaisesti, jotta pakettisi vastaavat laskutustasi. Myy lisää käyttöoikeuksia asiakkaiden kasvaessa ilman räätälöityjä toteutuksia jokaiselle paketille.",
        agencies_screen_2_title: "Hallitse pääsyä asiakaskohtaisesti",
        agencies_screen_3_badge: "Tekoäly",
        agencies_screen_3_bullets: [
            "Tarjoa tekoälyvastauksia, jotka tallenna asiakkaille tunteja viikossa",
            "Yhdistä Claude tai muut avustajat kunkin projektin MCP :n kautta",
            "Tuotteistuta tekoäly asiakkaille premium-lisäosana"
        ],
        agencies_screen_3_subtitle: "Älä vain hallitse arvosteluja. Anna asiakkaille tekoäly, joka luonnostelee vastauksia, tageaa palautetta ja toimii Clauden tai muiden assistenttien kanssa projektin MCP-palvelimen kautta. Se on moderni kyvykkyys, jonka toimistot voivat paketoida, myydä lisänä ja uusia — ilman sisältötiimiä jokaiselle tilille.",
        agencies_screen_3_title: "Tekoäly, josta asiakkaat maksavat",
        agencies_screen_4_badge: "Skaala",
        agencies_screen_4_bullets: [
            "Hallinnoi useiden yritysten arvostelut yhdeltä tililtä",
            "Lisää toimipisteitä sitä mukaa, kun voitat niitä, volyymihinnoittelulla",
            "Tee jokaisesta uudesta asiakkaasta toistuva tulonlähde"
        ],
        agencies_screen_4_subtitle: "Yksi toimistopaikka. Kymmeniä yrityksiä. Kerää arvosteluja, vastaa ja raportoi jokaisesta asiakastoimipisteestä yhdestä hubista, ja kasvata katetta tilejä lisätessäsi. Näin toimistot tekevät maineesta skaalautuvan tulovirran, ei kertaluonteista projektia.",
        agencies_screen_4_title: "Skaalaa jokaisen asiakkaan yli",
        agencies_summary_10_desc: "Yhdistä Claude tai muut avustajat projektien, asiakkaiden ja tiimin hallintaan.",
        agencies_summary_10_title: "Agentuurin MCP",
        agencies_summary_11_desc: "Jokainen asiakas saa käyttöönsä täyden arviointityökalupakin: kokoelman, tekoälyn, widgetit ja paljon muuta.",
        agencies_summary_11_title: "Kaikki liiketoiminnassa",
        agencies_summary_12_desc: "Saat apua tiimiltä, joka ymmärtää toimistojen työnkulut ja asiakashankinnat.",
        agencies_summary_12_title: "Omistettu tuki",
        agencies_summary_1_desc: "Clientit hallitsevat mainetta portaalissa, joka näyttää sinun rakentamaltasi tuotteelta.",
        agencies_summary_1_title: "Brändätty asiakasportaali",
        agencies_summary_2_desc: "Käytä portaalia omalla verkkotunnuksellasi, jotta jokainen kirjautuminen pysyy brändilläsi.",
        agencies_summary_2_title: "Mukautettu toimiston verkkotunnus",
        agencies_summary_3_desc: "Anna asiakkaiden kirjautua sisään identiteetintarjoajasi kautta yhdellä napsautuksella.",
        agencies_summary_3_title: "Kertakirjautuminen",
        agencies_summary_4_desc: "Kutsu asiakkaita tiettyihin projekteihin ja hallitse, mitä he voivat nähdä.",
        agencies_summary_4_title: "Client ja roolit",
        agencies_summary_5_desc: "Rajaa pyyntöjä, sijainteja ja ominaisuuksia projektikohtaisesti pakettiesi mukaan.",
        agencies_summary_5_title: "Projektikohtaiset ohitukset",
        agencies_summary_6_desc: "Anna sisäiselle tiimillesi täydet käyttöoikeudet kaikkiin asiakasprojekteihin.",
        agencies_summary_6_title: "Toimistotiimin paikat",
        agencies_summary_7_desc: "Aloita viidestä sijainnista ja lisää niitä volyymihinnoittelulla kasvaessasi.",
        agencies_summary_7_title: "Usean sijainnin mittakaava",
        agencies_summary_8_desc: "Järjestelmäilmoitukset lähetetään toimistosi verkkotunnuksesta ja projektikohtaisesti, kun asiakkaat eivät ole lisänneet omiaan.",
        agencies_summary_8_title: "White label -lähetys",
        agencies_summary_9_desc: "Automatisoi projekteja, asiakkaita ja tiimiä Agency API avulla.",
        agencies_summary_9_title: "Toimiston API",
        demo_footer: "Valitse sinulle sopiva aika. Käymme kaiken läpi ja vastaamme kysymyksiisi.",
        desc_contact: "Onko sinulla kysymys tai tarvitsetko apua johonkin? Lähetä viesti alle, niin hoidamme asian.",
        mcp_aria: "Tekoälyavustajademo yhdistetty More Good Reviews -sivustoon MCP kautta",
        mcp_prompts_aria: "Esimerkkikehotteita",
        review_flow_aria: "Korttikaruselli, jossa näkyvät sähköpostitse lähetetyt arvostelupyynnöt, arvostelusivu, Google arvostelut ja yksityiset palautteet",
        review_flow_autopilot: "Toimii autopilotilla",
        review_flow_card_email_desc: "Kun olet valmis asiakkaan kanssa, lähetämme automaattisesti sähköpostitse brändätyn pyynnön, joka sisältää yhdellä napautuksella linkin arvostelusivullesi.",
        review_flow_card_email_title: "Lähetä pyyntö",
        review_flow_card_feedback_desc: "Alemmat arvosanat avaavat ensin yksityisen palautteen, jotta voit korjata sen. Asiakkaat voivat edelleen valita julkisen arvostelun.",
        review_flow_card_feedback_title: "Nappaa kovaa palautetta",
        review_flow_card_google_desc: "Tyytyväiset asiakkaat saavat selkeän reitin jättää julkisen Google arvostelun, joten kehut näkyvät uusien asiakkaiden näkökulmasta.",
        review_flow_card_google_title: "Lähetä kiitosta Google",
        review_flow_card_review_desc: "He päätyvät arvostelusivullesi, valitsevat arvosanan ja seuraava vaihe riippuu siitä, miten kaikki meni.",
        review_flow_card_review_title: "Asiakas valitsee arvosanan",
        review_flow_next: "Seuraava vaihe",
        review_flow_prev: "Edellinen vaihe",
        review_flow_step_email: "Pyyntö Arvostelu",
        review_flow_step_feedback: "tai pyydä palautetta",
        review_flow_step_google: "Reitti mihin tahansa Arvostelu",
        review_flow_step_review: "Pyydä Arvosana",
        review_flow_steps_aria: "Arvostelu vaiheet",
        summary_10_desc: "Järjestä asiakkaat ja arvostelut , jotta voit suodattaa ja toimia nopeasti.",
        summary_10_title: "Asiakas ja arvostelutunnisteet",
        summary_11_desc: "Zapier yhdistää More Good Reviews jo käyttämiisi työkaluihin.",
        summary_11_title: "Yhdistä mihin tahansa sovellukseen",
        summary_12_desc: "Hallitse Claude, ChatGPT ja muiden MCP asiakkaiden mainetta.",
        summary_12_title: "MCP tekoälyavustajille",
        summary_1_desc: "Ajoitetut sähköposti- ja SMS muistutuksilla automaattisesti.",
        summary_1_title: "Automaattiset tarkistuspyynnöt",
        summary_2_desc: "Sähköpostit ja SMS , jotka sopivat brändiisi, äänesi ja tarjontaasi.",
        summary_2_title: "Brändätyt mallit",
        summary_3_desc: "Kerää yksityistä palautetta tai lähetä ihmisiä Google, Facebookiin ja muihin palveluihin.",
        summary_3_title: "Arvostelu",
        summary_4_desc: "Tulostettavat koodit ja koko näytön myymälänouto.",
        summary_4_title: "QR-koodit ja kioski",
        summary_5_desc: "Upota arvioita ja arvostelut mihin tahansa verkkosivustollesi.",
        summary_5_title: "Verkkosivuston widgetit",
        summary_6_desc: "Julkinen, brändättävä sivu parhaille arvostelut.",
        summary_6_title: "Showcase",
        summary_7_desc: "Tuo arvostelut ja vastaa niihin yhdestä paikasta.",
        summary_7_title: "Google ja Facebookin synkronointi",
        summary_8_desc: "Sivulla olevat ehdotukset, jotka auttavat asiakkaita jättämään arvostelun.",
        summary_8_title: "Apua tekoälyarvostelujen kirjoittamiseen",
        summary_9_desc: "Luo luonnosvastauksia, yhteenvetoja, trendejä ja kysy tekoälystä arvostelut.",
        summary_9_title: "Tekoälyn vastaukset ja näkemykset",
        subtitle_agencies_feature_summary: "White label -portaali, asiakaspääsy, skaalaus ja automaatio brändisi alla.",
        subtitle_ai_feature_summary: "Vastaukset, tägit, merkitykselliset tiedot ja avustajat sisäänrakennettuina maineen hallintatyönkulkuusi.",
        subtitle_feature_summary: "Keruu, näyttö, tekoäly ja integraatiot — valmiina kun sinä olet.",
        subtitle_mcp: "Yhdistä Claude, ChatGPT ja muut MCP-asiakkaat, ja kysy arvosteluista, toimipisteistä ja viestinnästä luonnollisella kielellä.",
        subtitle_review_flow: "Pyydä arvosteluja automaattisesti. Asiakkaat voivat jättää julkisen arvostelun milloin tahansa. Yksityinen palaute on valinnainen.",
        title: "Tekoälyn maineenhallinta",
        title_agencies: "Muuta arvostelut",
        title_agencies_feature_summary: "Kaikki mitä toimistot tarvitsevat",
        title_agencies_phrases: {
            branded_product: "omaksi brändätyksi tuotteeksi",
            recurring_retainers: "kuukausittaiset toistuvat retainerit",
            revenue_stream: "uudeksi tuloviraksi"
        },
        title_ai: "Kysy tekoälyltäsi",
        title_ai_feature_summary: "Kaikki mitä tekoäly voi tehdä puolestasi",
        title_ai_phrases: {
            weekly_report: "viikoittaista maineraporttia varten",
            send_from_chat: "lähettää arvostelupyyntöjä",
            next_steps: "seuraavia askeleita varten"
        },
        title_contact: "Kuinka voimme auttaa?",
        title_faq: "Yleisiä kysymyksiä",
        title_feature_summary: "Kaikki yhdessä paketissa",
        title_footer: "Lopeta arvostelujen jahtaaminen. Ala saada niitä.",
        title_footer_ai: "maineestasi",
        title_ltd: "Maksa kerran ja käytä ikuisesti rajoitetun ajan voimassa olevalla elinikäisellä tarjouksellamme",
        title_mcp: "Kysy tekoälyltä mainestasi",
        title_review_flow: "Muuta hyvät kokemukset arvosteluiksi",
        title_phrases: {
            autopilot: "pyytääkseen arvosteluja automaattisesti",
            google_reviews: "saadakseen lisää Google-arvosteluja",
            suggested_by_chatgpt: "saadakseen ChatGPT-ehdotuksia"
        },
        title_pricing: "Jokainen ominaisuus. Yksinkertainen hinnoittelu.",
        title_reviews: "Katso, miksi meidät on arvioitu #1 arvostelujen hallinnassa"
    },
    plans: {
        agency: {
            agency_api: "Toimiston API",
            branded_portal: "Brändätty asiakasportaali",
            client_invites: "Client kutsut, roolit ja ohitukset",
            custom_domain: "Mukautettu toimiston verkkotunnus",
            everything_in_business: "Kaikki liiketoimintasuunnitelmassa",
            locations_included: "Mukana 5 sijaintia",
            review_requests: "5 000 arviointipyyntöä \/ sijainti \/ kuukausi",
            sso: "Kertakirjautuminen (SSO)",
            support: "Omistettu asiakastuki",
            volume_pricing: "Määrähinta alkaen 49 $\/kk"
        },
        business: {
            ai: "Tekoälyn vastaukset, näkemykset ja Kysy tekoälystä",
            api_mcp: "API ja MCP Palvelin",
            custom_domains: "Mukautetut sähköposti- ja arvostelusivujen verkkotunnukset",
            google_facebook: "Google -yritysprofiili ja Facebook",
            locations_included: "1 sijainti mukana",
            review_requests: "{count} arvostelupyyntöjä \/ sijainti \/ kuukausi",
            support: "Omistettu asiakastuki",
            unlimited_customers: "Rajoittamaton määrä asiakkaita",
            volume_pricing: "Määrähinta alkaen 99 $\/kk"
        },
        descriptions: {
            agency: "Mainetoimistoille, jotka hallinnoivat asiakkaidensa mainetta brändinsä alla. Viisi toimipistettä ja tukkuhinnat kasvun myötä, sekä brändätty portaali ja asiakaskäyttöoikeus.",
            business: "Mainettaan itse hallinnoiville yrityksille. Maksa sijaintikohtaisesti ja hyödynnä määräalennukset. Saat tekoälyn, integraatiot ja rajoittamattoman määrän asiakkaita."
        },
        selectors: {
            agency_included: "{count} Mukana olevat sijainnit",
            agency_tier: "+{from}–{to} sijainnit · {price}\/{month} kukin",
            agency_tier_plus: "+{from}+ sijaintia · {price}\/{month} kukin",
            business_tier: "{from}–{to} sijainnit · {price}\/{month} kukin",
            business_tier_plus: "{from}+ sijaintia · {price}\/{month} kukin"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Lisää asiakas ja pyydä arvostelua",
            customers_to_ask: "Etsi asiakkaita, joilta voit pyytää arvostelut",
            location_leaderboard: "Vertaile sijainnin tehokkuutta",
            outreach_health: "Auditoi tiedotuksen toimituskunto",
            review_digest: "Viikoittainen katsaustiivistelmä",
            send_review_requests: "Lähetä arvostelupyyntöjä joukkona"
        },
        texts: {
            add_customer_and_ask: "Lisää uusi asiakas antamiani yhteystietoja käyttäen ja varaa sitten heille sähköpostitse arviointipyyntö, johon tulee kaksi muistutusta.",
            customers_to_ask: "Listaa jopa 50 asiakasta, joilta ei ole koskaan pyydetty arvostelua, lajiteltuna rekisteröitymispäivämäärän mukaan uusin ensin. Ohita kaikki peruuttaneet. Sisällytä nimi, sähköpostiosoite ja rekisteröitymispäivämäärä.",
            location_leaderboard: "Luo 90 päivän tulostaulukko sijainnin mukaan, joka sisältää arvostelujen määrän, keskimääräisen arvosanan, 5 tähden prosenttiosuuden ja trendin verrattuna edelliseen 90 päivään. Lajittele arvosanan mukaan ja merkitse kaikki yli 0,2 tähden pudotukset.",
            outreach_health: "Raportoi viimeisten 14 päivän aikana lähetettyjen sähköpostiviestien kokonaismäärä, toimitusprosentti, avausprosentti, klikkausprosentti ja epäonnistumisprosentti. Merkitse mahdolliset poikkeamat.",
            review_digest: "Tee yhteenveto kaikista arvostelut viimeisen seitsemän päivän ajalta. Sisällytä lukumäärä, keskimääräinen arvosana, erittely lähteen ja sijainnin mukaan, kolme yleisintä teemaa ja kolme yleisintä huolenaihetta.",
            send_review_requests: "Asiakkaille, jotka ovat rekisteröityneet viimeisten 30 päivän aikana ja joilta ei ole pyydetty arvostelua, varaa sähköpostitse arvostelupyyntö, johon tulee kaksi muistutusta. Näytä ensin lista ja odota vahvistustani."
        }
    },
    messages: {
        activated: "Aktivoitu onnistuneesti.",
        archived: "Arkistoitu onnistuneesti.",
        canceled: "Peruutettu onnistuneesti.",
        cannot_copy: "Leikepöydälle kopiointi epäonnistui",
        cname_active: "CNAME tila on aktiivinen.",
        cname_not_active: "CNAME tila ei ole vielä aktiivinen.",
        connected: "Yhdistetty onnistuneesti.",
        cookie_banner_text: "Käytämme evästeitä käyttökokemuksesi parantamiseksi. Voit mukauttaa asetuksiasi tai hyväksyä kaikki.",
        cookie_category_analytics_desc: "Käytetään verkkosivuston liikenteen ja tuotteiden käytön mittaamiseen. Nämä evästeet auttavat meitä ymmärtämään, miten kävijät käyttävät sivustoamme.",
        cookie_category_essential_desc: "Aina aktiivinen. Nämä evästeet ovat välttämättömiä sivuston toiminnalle, eikä niitä voi poistaa käytöstä.",
        cookie_category_functional_desc: "Ota käyttöön parannetut ominaisuudet, kuten live-chat. Nämä evästeet eivät seuraa sinua mainostarkoituksiin.",
        cookie_category_marketing_desc: "Käytetään mainontaan ja kampanjoiden mittaamiseen. Näitä voivat olla mainospikselit ja attribuutiotyökalut.",
        copied: "Kopioitu onnistuneesti.",
        copied_to_all_ratings: "Kopioitu kaikkiin arvioihin. Tallenna ottaaksesi käyttöön.",
        created: "Luotu onnistuneesti.",
        deactivated: "Deaktivoitu onnistuneesti.",
        deleted: "Poistettu onnistuneesti.",
        disconnected: "Yhteys katkaistu onnistuneesti.",
        duplicated: "Kopioitu onnistuneesti.",
        error: "Jotain meni pieleen. Yritä uudelleen.",
        google_connect_failed: "Emme voineet muodostaa yhteyttä Google. Voit yrittää uudelleen tai ohittaa tämän nyt.",
        inquiry_sent: "Kiitos yhteydenotostasi. Otamme yhteyttä pian.",
        oauth_consent_intro: "{client} pyytää lupaa käyttää tiliäsi.",
        oauth_request_missing: "OAuth-valtuutuspyyntö puuttuu tai on vanhentunut.",
        operation_connection_sync_failed: "{integration_name}-synkronointi epäonnistui.",
        operation_connection_sync_progress: "Synkronoidaan {integration_name}…",
        operation_connection_sync_success: "{integration_name} synkronointi valmis.",
        operation_customer_import_failed: "Asiakas tuonti epäonnistui.",
        operation_customer_import_progress: "Asiakkaiden tuonti…",
        operation_customer_import_success: "Asiakas tuonti valmis.",
        operation_review_import_failed: "Arvostelu tuonti epäonnistui.",
        operation_review_import_progress: "Tuodaan arvostelut…",
        operation_review_import_success: "Arvostelu tuonti valmis.",
        operation_review_scrape_failed: "Viimeisimmän arvostelun tuonti epäonnistui.",
        operation_review_scrape_progress: "Tuodaan viimeaikaisia arvostelut…",
        operation_review_scrape_success: "Viimeisimpien arvostelujen tuonti valmis.",
        processed: "Käsitelty onnistuneesti.",
        published: "Julkaistu onnistuneesti.",
        purchased: "Ostettu onnistuneesti.",
        queued: "Ajoitettu onnistuneesti.",
        refreshed: "Päivitetty onnistuneesti.",
        removed: "Poistettu onnistuneesti.",
        resubscribed: "Uudelleentilaus onnistui.",
        revoked: "Peruutettu onnistuneesti.",
        saved: "tallennettu onnistuneesti.",
        scheduled: "Ajoitettu onnistuneesti.",
        sent: "Lähetetty onnistuneesti.",
        started: "Käynnistetty onnistuneesti.",
        stopped: "Pysäytys onnistui.",
        sso_failed: "Kertakirjautumisen (SSO) valtuutus ei onnistu.",
        sso_invalid_callback: "Virheellinen kertakirjautumiskutsu.",
        sso_not_configured: "Kertakirjautumista ei ole määritetty.",
        sso_openid_config_failed: "OpenID-määrityksen lataaminen epäonnistui.",
        sso_token_exchange_failed: "SSO-tunnuksen vaihtoa ei voitu suorittaa loppuun.",
        subscribed: "Tilaus onnistui.",
        suspended: "Jäädytetty onnistuneesti.",
        synced: "Synkronoitu onnistuneesti.",
        unarchived: "Arkistoinnin poistaminen onnistui.",
        unpublished: "Julkaisun peruutus onnistui.",
        unscheduled: "Ajoitus poistettu onnistuneesti.",
        unsubscribed: "Tilauksen peruutus onnistui.",
        unsuspended: "Jäädytyksen poisto onnistui.",
        updated: "Päivitetty onnistuneesti.",
        upgraded: "Päivitys onnistui.",
        validated: "Vahvistettu onnistuneesti.",
        verified: "Vahvistettu onnistuneesti."
    },
    notices: {
        agency: "Pyöritätkö toimistoa? Voit white label -merkitä tuotteemme, jotta asiakkaasi näkevät brändisi vain palvelua käyttäessään.",
        ai_tags: "Luo tekoälytagi, jotta ohjeitasi vastaavat arvostelut merkitään automaattisesti.",
        connected_apps: "MCP kautta yhdistämäsi sovellukset näkyvät tässä.",
        connector: "Tuo asiakkaasi tuhansista sovelluksista {brand}:n avulla.",
        customer_messages: "Pyydä arvostelua viestien ajoittamiseksi.",
        customer_reviews: "Pyydä arvostelua tältä asiakkaalta.",
        customers: "Tuo asiakkaasi aloittaaksesi arvostelut pyytämisen.",
        customers_import_yourself: "Tuo asiakkaasi aloittaaksesi arvostelut pyytämisen. Voit myös tuoda ensin itsesi ja kokeilla prosessia ennen kuin kutsut muita.",
        external_links: "Lisää ulkoisia linkkejä asiakasportaaliisi palveluidesi myynnin helpottamiseksi. Nämä linkit näkyvät asiakkaillesi sivupalkissa.",
        links: "Lisää sivullesi painikkeita, joilla voit jättää arvostelut kolmansien osapuolten verkkosivustoille.",
        locations: "Luo sijainti, jotta voit liittää arvostelut useisiin sijainteihin.",
        ltd: "Avaa elinikäinen käyttöoikeus koodillasi. Jokainen koodi sisältää rajoitetun määrän kuukausittaisia pyyntöjä sekä kaikki ominaisuudet. Koodit ovat pinottavia. Kolme tai useampi koodi avaa toimistosuunnitelman. Syötä käyttöoikeuskoodisi alla olevaan kenttään.",
        mcp_example_prompts: "Kun MCP palvelin on yhdistetty, liitä nämä avustajaasi lähtökohdaksi.",
        messages: "Jokainen pyyntö ja muistutus näkyy täällä, kun asiakkailtasi pyydetään arvosteluja.",
        no_commissions: "Et ole vielä ansainnut palkkioita.",
        no_payouts: "Maksut lähetetään manuaalisesti, kun hyväksytty saldosi on vähintään 50,00 dollaria ja pankkitilisi on yhdistetty.",
        no_projects: "Sinulle ei ole vielä määritetty projektia. Ota yhteyttä ylläpitäjään saadaksesi käyttöoikeuden.",
        no_referrals: "Et ole vielä suositellut ketään. Jaa suosittelulinkkisi aloittaaksesi.",
        qr_codes: "Luo QR-koodeja mukautetuilla väreillä, sijainneilla ja tagit. Lataa SVG tai PNG muodossa.",
        referrals_share_subject: "Tekoälyn maineenhallitsija",
        referrals_share_text: "Salainen aseeni arvostelut saamiseksi: Lisää hyviä arvosteluja. Tekoälyyn perustuva maineenhallinta, joka todella toimii. Rekisteröidy linkilläni:",
        review_pages: "Projektissasi voi olla useita arvostelusivuja, joille asiakkaasi voivat jättää arvostelut. Tämä on hyödyllistä yrityksille, joilla on useampi kuin yksi toimipiste.",
        reviews: "Odotamme asiakkaidesi arvosteluja.",
        showcase: "Olemme vasta aloittamassa.",
        signatures: "Luo sähköpostiallekirjoitus, jonka voit kopioida ja liittää sähköpostisovellukseesi.",
        sources: "Luo lähde, jotta voit luokitella arvostelut.",
        tag_rules: "Luo sääntö, joka luokittelee arvostelut automaattisesti tekoälyn avulla.",
        tags: "Luo tag luokitellaksesi arvostelusi ja asiakkaasi.",
        unauthorized: "Sinulla ei ole oikeutta käyttää tätä sivua.",
        unsubscribed: "Olet nyt peruuttanut tilauksesi arviointipyyntöihin.",
        webhooks: "Lisää webhookeja saadaksesi ilmoituksia alustan tapahtumista.",
        widgets: "Luo widgetejä upottaaksesi arvostelut verkkosivustollesi.",
        your_referral_link_text: "Jaa linkkisi ansaitaksesi {rate}% toistuvaa palkkiota jokaisesta suosittelemiesi asiakkaiden maksusta. Maksut lähetetään manuaalisesti, kun hyväksytty saldosi saavuttaa vähintään 50,00 dollaria."
    },
    notification_types: {
        descriptions: {
            imports: "Lähetetään, kun tuonnit on suoritettu",
            new_reviews: "Lähetetään, kun arvostelut on vastaanotettu",
            sent_replies: "Lähetetään, kun arvostelut vastataan automaattisesti",
            weekly_reports: "Viikoittain lähetettävä yhteenveto toiminnasta"
        },
        names: {
            imports: "Tuonti",
            new_reviews: "Uudet Arvostelut",
            sent_replies: "Lähetetyt vastaukset",
            weekly_reports: "Viikkoraportit"
        }
    },
    roles: {
        admin: "Ylläpitäjä",
        manager: "Johtaja",
        operator: "Operaattori",
        owner: "Omistaja",
        super_admin: "Super-ylläpitäjä",
        viewer: "Katselija"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Hyväksy kutsu",
        accepting_invite: "Kutsun hyväksyminen",
        access_denied: "Käyttö estetty",
        account: "Tili",
        actions: "Toiminnot",
        add_custom_field: "Lisää mukautettu kenttä",
        add_ons: "Lisäosat",
        address: "Osoite",
        agencies: "Toimistot",
        agency: "Toimisto",
        ai: "Tekoäly",
        ai_assistant: "Tekoälyavustaja",
        ai_highlights: "Tekoälyn kohokohdat",
        ai_replies: "Tekoälyn vastaukset",
        ai_review_suggestions: "Tekoälyn Arvostelu",
        ai_tags: "Tekoälytagit",
        ai_tools: "Tekoälytyökalut",
        analytics: "Analytiikka",
        api: "API",
        api_key: "API-avain",
        appearance: "Ulkonäkö",
        application_connectors: "Sovellusliittimet",
        attributes: "Ominaisuudet",
        authorize: "Valtuuta",
        auto_tagging: "Automaattinen tunnisteiden lisääminen",
        automate: "Automatisoi",
        automatic_review_collection: "Automaattinen Arvostelu kerääminen",
        billing: "Laskutus",
        branding: "Brändäys",
        change_password: "Vaihda salasana",
        clients: "Asiakkaat",
        cname: "CNAME",
        conditions: "Edellytykset",
        confirmation_message: "Vahvistusviesti",
        connected_apps: "Yhdistetyt sovellukset",
        contact_us: "Ota yhteyttä",
        cookie_policy: "Evästekäytäntö",
        cookie_preferences: "Evästeasetukset",
        copy: "Kopioi",
        create_your_account: "Luo tili",
        crms: "CRM-järjestelmät",
        css: "CSS",
        custom_field: "Mukautettu kenttä",
        custom_fields: "Mukautetut kentät",
        custom_icons: "Mukautetut kuvakkeet",
        customer: "Asiakas",
        customer_facing_pages: "Asiakkaille suunnatut sivut",
        customers: "Asiakkaat",
        dashboard: "Kojelauta",
        details: "Tiedot",
        dmarc: "DMARC",
        domain: "Verkkotunnus",
        dpa: "Tietojenkäsittelysopimus",
        dsar: "Rekisteröidyn tiedonsaantipyyntö",
        email_address: "Sähköpostiosoite",
        email_messages: "Sähköpostiviestit",
        email_settings: "Sähköpostiasetukset",
        email_usage: "Sähköpostin käyttö",
        emails: "Sähköpostit",
        embed_code: "Upota koodi",
        examples: "Esimerkkejä",
        export: "Vie",
        external_link: "Ulkoinen Linkki",
        external_link_num: "Ulkoinen Linkki #{num}",
        external_links: "Ulkoiset Linkit",
        field: "Ala",
        fields: "Kentät",
        filters: "Suodattimet",
        form_fields: "Lomakekentät",
        got_access_code: "Onko sinulla pääsykoodi?",
        hipaa: "HIPAA-lausunto",
        how_it_works: "Miten se toimii",
        incentive: "Kannustin",
        instructions: "Ohjeet",
        integration: "Integraatio",
        integrations: "Integraatiot",
        javascript: "JavaScript",
        latest_reviews: "Viimeisimmät Arvostelut",
        lifetime_deal: "Elinikäinen tarjous",
        limits: "Rajat",
        link: "Linkki",
        links: "Linkit",
        location: "Sijainti",
        location_picker: "Sijainnin valitsin",
        locations: "Sijainnit",
        log_in: "Kirjaudu sisään",
        log_out: "Kirjaudu ulos",
        make_default: "Aseta oletukseksi",
        manage_limits: "Hallitse rajoja",
        manage_overrides: "Hallinnoi ohituksia",
        manage_review: "Hallinnoi Arvostelu",
        mcp_example_prompts: "Esimerkkikehotteita",
        mcp_server: "MCP Palvelin",
        message: "Viesti",
        messages: "Viestit",
        meta: "Meta",
        no_clients: "Ei asiakkaita",
        no_commissions: "Ei palkkioita",
        no_connected_apps: "Ei yhdistettyjä sovelluksia",
        no_custom_fields: "Ei mukautettuja kenttiä",
        no_customers: "Ei asiakkaita",
        no_links: "Ei Linkit",
        no_locations: "Ei sijainteja",
        no_members: "Ei jäseniä",
        no_messages: "Ei viestejä",
        no_payouts: "Ei maksuja",
        no_projects: "Ei projekteja",
        no_qr_codes: "Ei QR-koodeja",
        no_referrals: "Ei viittauksia",
        no_review_pages: "Ei Arvostelusivut",
        no_reviews: "Ei Arvostelut",
        no_tags: "Ei Tagit",
        no_team_members: "Ei tiimin jäseniä",
        no_template: "Ei mallipohjaa",
        no_widgets: "Ei widgetejä",
        notifications: "Ilmoitukset",
        options: "Asetukset",
        overview: "Yleiskatsaus",
        payment_method: "Maksutapa",
        photo: "Kuva",
        plans: "Suunnitelmat",
        powered_by: "Powered by",
        pricing: "Hinnoittelu",
        privacy_policy: "Tietosuojakäytäntö",
        profile: "Profiili",
        project: "Projekti",
        project_limits: "Projektin rajoitukset",
        project_overrides: "Projektin ohitukset",
        projects: "Projektit",
        qr_code: "QR-koodi",
        qr_codes: "QR-koodit",
        ratings: "Arviot",
        redeem_access_code: "Lunasta käyttöoikeuskoodi",
        redirecting: "Uudelleenohjaus",
        redirects: "Uudelleenohjaukset",
        referrals_commissions: "Palkkiot",
        referrals_payouts: "Maksut",
        referral_program: "Suositteluohjelman ehdot",
        reminders: "Muistutukset",
        reply: "Vastaa",
        request: "Pyyntö",
        request_options: "Pyyntövaihtoehdot",
        requests: "Pyynnöt",
        required: "Pakollinen",
        reschedule_message: "Ajoita viesti uudelleen",
        reset_password: "Palauta salasana",
        retries: "Uudelleenyritykset",
        review: "Arvostelu",
        review_link: "Arvostelulinkki",
        review_page: "Arvostelusivu",
        review_pages: "Arvostelusivut",
        review_spotlight: "Arvostelunosto",
        review_suggestions: "Arvosteluehdotukset",
        review_wall: "Arvosteluseinä",
        reviewer: "Arvostelija",
        reviews: "Arvostelut",
        save_changes: "Tallenna muutokset",
        schedule: "Ajoittaa",
        scrape_a_website: "Kerää verkkosivustolta",
        search_engines: "Hakukoneet",
        sections: "Osiot",
        select_csv_file: "Valitse CSV-tiedosto",
        select_project: "Valitse projekti",
        selecting_project: "Projektin valitseminen",
        sending_domain: "Lähettävä verkkotunnus",
        sending_limits: "Lähetysrajoitukset",
        settings: "Asetukset",
        setup: "Asennus",
        setup_basics: "Pyyntö",
        setup_business: "Aloitetaan",
        setup_google: "Google yritysprofiilisi",
        setup_trusted: "Yli 5 000 yrityksen luottama",
        showcase: "Showcase",
        sign_up: "Rekisteröidy",
        signature: "Allekirjoitus",
        signatures: "Allekirjoitukset",
        signing_in: "Kirjautuminen",
        single_sign_on: "Kertakirjautuminen",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "Tekstiviestit",
        sms_usage: "Tekstiviestien käyttö",
        smtp_configuration: "SMTP-konfiguraatio",
        source: "Lähde",
        sources: "Lähteet",
        space: "Työtila",
        spaces: "Työtilat",
        stats: "Tilastot",
        sub_processors: "Alikäsittelijät",
        success_page: "Menestyssivu",
        summary: "Yhteenveto",
        tag: "Tag",
        tag_rule: "Tag sääntö",
        tags: "Tagit",
        team_members: "Tiimin jäsenet",
        template: "Mallipohja",
        templates: "Mallit",
        terms_of_service: "Palveluehdot",
        two_factor_authentication: "Kaksivaiheinen todennus",
        unable_to_complete_request: "Pyyntöä ei voitu suorittaa",
        unique_review_link: "Yksilöllinen arvostelulinkki",
        unsent_messages: "Lähettämättömät viestit",
        unsubscribe: "Peruuta tilaus",
        update_plan: "Päivityssuunnitelma",
        usage: "Käyttö",
        user: "Käyttäjä",
        user_info: "Käyttäjätiedot",
        verify_email_address: "Vahvista sähköpostiosoite",
        verifying_email: "Sähköpostin vahvistaminen",
        visibility: "Näkyvyys",
        webhook: "Webhook",
        webhooks: "Webhookit",
        website: "Verkkosivusto",
        white_label_api: "White Label -API",
        white_label_client_portal: "White Label -asiakasportaali",
        white_label_image_urls: "White Label -kuvien URL-osoitteet",
        white_label_sending_domain: "White Label -lähetysverkkotunnus",
        white_label_widget_tag: "White Label -widget- Tag",
        widget: "Widget",
        widget_num: "Widget #{num}",
        widgets: "Widgetit",
        your_plan: "Sinun suunnitelmasi"
    },
    tones: {
        apologetic: "Apologeettinen",
        casual: "Rento",
        empathetic: "Empaattinen",
        enthusiastic: "Innostunut",
        formal: "Muodollinen",
        friendly: "Ystävällinen",
        grateful: "Kiitollinen",
        humorous: "Humoristinen",
        informative: "Informatiivinen"
    },
    widgets: {
        labels: {
            alignment: "Tasaus",
            animation: "Animaatio",
            autoplay: "Automaattinen toisto",
            autoplay_delay: "Automaattisen toiston viive",
            avatar: "Avatar",
            background_color: "Taustaväri",
            border: "Reuna",
            border_color: "Reunuksen väri",
            border_radius: "Reunuksen säde",
            border_width: "Reunuksen leveys",
            carousel: "Karuselli",
            colors: "Värit",
            company: "Yritys",
            customer: "Asiakas",
            customer_position: "Asiakkaan asema",
            date: "Päivämäärä",
            delay: "Viive",
            design: "Ulkoasu",
            design_prompt_placeholder: "Esimerkki: Pehmeä ja minimalistinen, kultaiset tähdet ja pyöristetyt kulmat.",
            drop_shadow: "Varjon heitto",
            duration: "Kesto",
            filters: "Suodattimet",
            font: "Fontti",
            font_emphasis: "Fontin painotus",
            font_family: "Fonttiperhe",
            font_size: "Fonttikoko",
            include_hidden: "Sisällytä piilotetut Arvostelut",
            layout: "Layout",
            limit: "Arvostelut sivulla",
            location_ids: "Sijainnit",
            marquee: "Marquee",
            max_slides: "Max Slides",
            max_width: "Maksimileveys",
            name_convention: "Nimi",
            padding: "Täyte",
            pagination: "Sivunumerointi",
            quotes: "Lainausmerkit",
            rating: "Arvosana",
            rating_round: "Pyöristäminen",
            rating_round_hundredth: "Lähimpään sadasosaan (4,94)",
            rating_round_tenth: "Lähimpään kymmenesosaan (4,9)",
            review: "Arvostelu",
            review_chars: "Arvostelu pituus",
            review_count: "Arvostelu määrä",
            review_id: "Arvostelu",
            review_ids: "Arvostelut",
            review_ids_for_faces: "Arvostelut tuotteelle Faces",
            reviews: "Arvostelut",
            schema: "Schema",
            schema_name: "Yrityksen nimi",
            schema_type: "Liiketoiminnan tyyppi",
            score: "Alin luokitus",
            show_on_mobile: "Näytä mobiililaitteella",
            slider: "Liukusäädin",
            sort: "Järjestellä",
            source: "Lähde",
            source_ids: "Lähteet",
            source_position: "Lähteen sijainti",
            speed: "Nopeus",
            star_color: "Tähden väri",
            star_display: "Tähtien näyttö",
            star_size: "Tähden koko",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Tagit",
            take: "Arvostelut enimmäismäärä",
            text_color: "Tekstin väri",
            truncate: "Lyhennä Arvostelu",
            visible_slides: "Näkyvät diat",
            width: "Leveys"
        },
        types: {
            badge: "Kunniamerkki",
            carousel: "Karuselli",
            carousel_dynamic: "Dynaaminen karuselli",
            corner: "Kulma",
            corner_dynamic: "Dynaaminen kulma",
            faces: "Kasvot",
            headline: "Otsikko",
            highlights: "Kohokohdat",
            marquee: "Marquee",
            spotlight: "Nosto",
            wall: "Seinä"
        }
    }
}
